import classnames from 'classnames';
import moment from 'moment';
import React, { Component, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// utils
import {
  Translations,
  consoleLog,
  convertStringToArray,
  convertStringToArrayForRadio,
  electOwningCase,
  getProjectStatus,
  isEmptyObject,
  shoudlDisableAllCaseBodyFooterBtns,
  shoudlDisableCancelBtn,
  shoudlEnableGenerateDraftBtn
} from '../../../utils';
// constants
import {
  ACH_UK,
  AWAITING_SIGNATURE,
  CASE_COMPLETED,
  CASE_STATUS_LEVEL_LOOKUP_TABLE,
  DOCUMENTATION_DRAFT,
  FORM_REFS,
  ROLES
} from '../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../restClient';
// children
import Banner from '../../common/Banner';
import Checkbox from '../../common/Checkbox/';
import Dynamicform from '../../common/Dynamicform/dynamicForm';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../common/Modal';
import RadioButton from '../../common/RadioButton/radioButton';
import TelephoneNumber from '../../common/TelephoneNumber';
import { FinalizeBgProcessModal, FinalizeDocumentsModal } from '../Modals';
// feature flags utils
import { isTbtEnabled } from '../../../featureFlags';
// actionCreator
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import { cryptoPass } from '../../../utils';
import { setCases, updateCasesWithStatus } from '../../createAcase/actions/actionCreator';
import { updateDarkTitleBarCaseStatus } from '../../layouts/actions/actionCreator';
import {
  disableAllCaseBodyFooterBtns,
  disableCaseBodyFooterBtn,
  disableTab,
  enableCaseBodyFooterBtn,
  enableTab,
  setTabsStatus
} from '../actions/actionCreator';
// styles
import './CaseDocument.css';

class CaseDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxStatus: false,
      documentation: '',
      finalize_document: '',
      finalizeBtnStatuses: {},
      showFinalizeModalDialog: false,
      showMarkedModalDialog: false,
      data: '',
      bannersVisibility: {},
      scannedUploads: [],
      currentCaseDocumentationData: undefined,
      lastButtonClicked: undefined,
      showSignatoryModalDialog: false,
      showSignatoryConfirmationModalDialog: false,
      showESignModalDialog: false,
      showESignSignatoryModalDialog: false,
      showESignConfirmationModalDialog: false,
      showSentForESignModal: false,
      showCancelEsignConfirmationModalDialog: false,
      showEsignCanceledModalDialog: false,
      signupCountry: [],
      signupCountryObj: [],
      telephoneCountryCodes: [],
      telephoneAreaCodes: [],
      associatedGlsProducts: [],
      showFinalizeDocumentsModalDialog: false,
      caseIdsForFinalization: [],
      selectAllFinalizeFlag: false,
      isFinalizeConfirmationChecked: false,
      showFinalizeBgProcessModal: false,
      caseDocumentationPaths: []
    };
    this.scannedDocuments = [];
    this.caseStatuses = [];
    this._renderContent = this._renderContent.bind(this);
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  loadDocumentationPageState = async (cb) => {
    this.props.blockUi();
    let tab = await cryptoPass('documentation-tab',);
    window.sessionStorage.removeItem("tab");
    window.localStorage.setItem('tab', tab);
    eapiClient("/cases/" + this.props.owningCase.caseId + "/doc-status", { timeout: 420000 })
      .then(({ data }) => {
        this.props.updateDarkTitleBarCaseStatus(getProjectStatus(this.props.owningCase.caseId, data.responseData.caseStatuses));
        this.props.setTabsStatus('documentationTab', data.responseData.tabStatus === "complete");
        this.caseStatuses = data.responseData.caseStatuses;

        const { caseStatuses } = data.responseData;
        this.props.updateCasesWithStatus(caseStatuses);

        if (shoudlEnableGenerateDraftBtn(caseStatuses)) {
          this.props.enableCaseBodyFooterBtn('generateDocumentationBtn');
        } else {
          this.props.disableCaseBodyFooterBtn('generateDocumentationBtn');
        }

        // disable/enable cancel case button logic
        if (shoudlDisableCancelBtn(caseStatuses)) {
          this.props.disableCaseBodyFooterBtn('cancelBtn');
        } else {
          this.props.enableCaseBodyFooterBtn('cancelBtn');
        }
        if (shoudlDisableAllCaseBodyFooterBtns(caseStatuses)) {
          this.props.disableAllCaseBodyFooterBtns();
        }
        this.setState({ data: data.responseData.data });
        if (cb && typeof (cb) === "function") {
          cb();
        }
        // Check to find if E-sign is completed for at least one entity - Enable the Activation tab based on it
        // For E-sign completed cases, if 'Pending signature' is selected in the 'Mark document signed' popup, the case status becomes 'Documentation, awaiting signature' - the Activation tab should stay disabled
        let isEsignComplete = false, currentCaseStatus;
        isEsignComplete = data.responseData.data.some(caseData => caseData.eSignStatus !== null && caseData.eSignStatus.overallStatus === 'completed');
        currentCaseStatus = caseStatuses.find(status => status.caseId === this.props.owningCase.caseId);
        if (isEsignComplete && currentCaseStatus.statusKey !== AWAITING_SIGNATURE) {
          this.props.enableTab(3);
        }
        this.props.unBlockUi();
      });
  }

  componentDidMount() {
    /*===========================static data fetch call===========================*/
    aemHostClient("/aemData/formData/json_documentation")
      .then(({ data, status }) => {
        this.setState({ pageJson: data.par });

        return aemHostClient("/aemData/formData/json_documentation-finalised")
      })

      /*===========================Documentation finalise Modal data fetch call===========================*/

      .then(({ data, status }) => {
        this.setState({ pageJsonModal: data.par });

        return aemHostClient("/aemData/formData/json_documentation-declaration-signature")
      })

      /*===========================Declaration signatory and E-sign popup modal json ===========================*/

      .then(({ data, status }) => {
        this.setState({ signatoryJsonModal: data.par });

        return aemHostClient("/aemData/formData/json_declaration-signature-sendtosimplesign-confirmation")
      })

      /*===========================Declaration signatory modal json ===========================*/

      .then(({ data, status }) => {
        this.setState({ signatoryConfirmationJsonModal: data.par });

        return aemHostClient("/aemData/formData/json_sentForESignPositiveMessage")
      })


      .then(({ data, status }) => {
        this.setState({ sentForEsignModalDetails: data.par.static_text_documentation });

        return aemHostClient("/aemData/formData/json_sentForESignNegativeMessage")
      })


      .then(({ data, status }) => {
        this.setState({ sentForEsignNegativeMsg: data.par.static_text_documentation.description });

        return aemHostClient("/aemData/formData/json_dark-title-bar")
      })

      /*===================Dark title bar page json =================*/

      .then(({ data }) => {
        this.setState({ darkTitleBarJson: data.par });
        document.title = `${Translations(data.par.static_text_darkTitleBar.documentation, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`

        return aemHostClient("/aemData/formData/json_mark-as-signed")
      })
      /*===================Marked signed popup page json =================*/

      .then(({ data, status }) => {
        this.setState({ formJson: data.par })
      });
    /*===========================Esign eligible countries taxonomy API call===========================*/
    taxonomyHostClient("/taxonomies/esign/countries")
      .then(({ data }) => {
        let signupCountryList = [];

        for (const element of data.responseData.classificationNodes) {
          signupCountryList.push(element.name)
        }

        this.setState({
          signupCountry: signupCountryList,
          signupCountryObj: data.responseData.classificationNodes
        });
      });

    /*===========================country and area codes taxonomy API call===========================*/
    taxonomyHostClient("/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:eSignTelephoneCountryCodes")
      .then(({ data }) => {
        this.setState({ telephoneCountryCodes: data.responseData.classificationNodes });
      });

    taxonomyHostClient("/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:telephoneAreaCodes")
      .then(({ data }) => {
        this.setState({ telephoneAreaCodes: data.responseData.classificationNodes });
      });

    this.loadDocumentationPageState();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.caseMenu !== nextProps.caseMenu) {
      this.loadDocumentationPageState();
    }
  }

  getBasicDetails = (basicDetails) => {
    this.setState({ basicDetails });
  }

  renderMarkedpopupFormGroup = () => {
    let formData, mode;
    if (this.state.currentCaseDocumentationData && this.state.currentCaseDocumentationData.id) {
      mode = 'edit';
      if (this.state.currentCaseDocumentationData.statusKey === CASE_COMPLETED) {
        let _currentCaseDocumentationData = { ...this.state.currentCaseDocumentationData }
        _currentCaseDocumentationData.statusKey = "urn:hsbc:cmb:gdocs:cases:taxonomies:status:awaitingActivation";
        _currentCaseDocumentationData.oldStatusKey = this.state.currentCaseDocumentationData.statusKey;
        this.setState({ currentCaseDocumentationData: _currentCaseDocumentationData })
        formData = _currentCaseDocumentationData;
      } else {
        formData = this.state.currentCaseDocumentationData;
      }

    } else {
      formData = {};
    }
    const properties = {
      formData,
      editType: 'marked-pop-up',
      pathname: "/case-body/"
    };
    if (this.state.formJson !== undefined && this.state.formJson.aemform_markSigned !== undefined) {
      var aemform = this.state.formJson.aemform_markSigned;
      var formRef = this.state.formJson.aemform_markSigned.formRef;
      var pageTitle = this.state.formJson.page_title_mainTitle.pageHeading;
      if (this.state.showMarkedModalDialog && aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform mode={mode}
            properties={properties}
            pageTitle={pageTitle}
            hideButtons={true}
            getFormData={this.getBasicDetails}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            flag={this.props.lang.currentLangFlag.flag} />
        );
      }
    }
  }

  /*===========================send finalize data===========================*/
  _checkStatus(items) {
    let _status = '';
    let checkStatus = items ? items.split(':') : '';
    switch (checkStatus[checkStatus.length - 1]) {
      case 'DocumentationDraft':
        _status = 'icon icon-circle-confirmation-solid iconSigned';
        break;
      case 'incomplete':
        _status = 'icon icon-circle-error-solid gdoc-tab-iconSigned';
        break;
      default:
        _status = '';
    }
    return _status;
  }

  _checkStatusSigned(items) {
    let checkStatus = items ? items.split(':') : '';
    return checkStatus[checkStatus.length - 1];
  }

  _documentationHandler(item, buttonType, index) {
    let eventId = `finalize_doc_btn${index}`
    console.log(eventId);
    this.setState({ lastButtonClicked: eventId });
    if (buttonType === 'signedDate') {
      this.openMarkedSignedModalDialog(item);
    } else if (buttonType === 'finalizeDate') {
      this.openMarkedSignedModalDialog(item);
    } else if (buttonType === 'generateDate') {
      this.openFinalizeModalDialog(item);
    } else if (buttonType === 'simpleSign') {
      const docStatusData = this.state.data;
      const rafCountryListMap = new Map();
      docStatusData.forEach((caseData) => {
        rafCountryListMap.set(
          caseData.id,
          caseData.rafSafCList.map((country) =>
            country === "España"
              ? "Spain"
              : country === "México" ? "Mexico" : country
          )
        );
      });

      const { cases } = this.props;

      let achUKProductCountryList = []
      const achProductCountryList = cases && cases[item.id && item.id] && cases[item.id && item.id].productDatas && cases[item.id].productDatas.filter(item => item.name === 'ACH-Credit') || []
      achUKProductCountryList = achProductCountryList.length > 0 ? achProductCountryList.filter(item => {
        return item.country.includes(ACH_UK)
      }).map(item => item.country) : [];

      const rafCountryList = rafCountryListMap.get(item.id) !== undefined ? rafCountryListMap.get(item.id) : []

      const signupCountryList = rafCountryList.filter((item) => {
        return this.state.signupCountry.indexOf(item) !== -1
      })

      const nonSignupCountryList = rafCountryList.filter((item) => {
        return this.state.signupCountry.indexOf(item) === -1
      })

      // Simple sign scenario - BACS flow
      if (achUKProductCountryList.length > 0) {
        this.setState({
          isESignCountry: signupCountryList.length > 0 && nonSignupCountryList.length === 0 ? true : false,
          currentCaseid: item.id,
          bacsFlow: true,
          showESignModalDialog: true,
          currentItem: item
        });
      } else { // E-sign scenario - Non-BACS flow
        this.setState({
          signupProductCountryListEsign: signupCountryList,
          showESignModalDialog: true,
          isESignCountry: signupCountryList.length > 0 && nonSignupCountryList.length === 0 ? true : false,
          currentCaseid: item.id,
          bacsFlow: false,
          currentItem: item
        });
      }
    }
    else if (buttonType === 'cancelEsign') {
      const docStatusData = this.state.data;
      const rafCountryListMap = new Map();
      docStatusData.forEach((caseData) => {
        rafCountryListMap.set(
          caseData.id,
          caseData.rafSafCList.map((country) =>
            country === "España"
              ? "Spain"
              : country === "México" ? "Mexico" : country
          )
        );
      });

      const { cases } = this.props;

      let achUKProductCountryList = []
      const achProductCountryList = cases && cases[item.id && item.id] && cases[item.id && item.id].productDatas && cases[item.id].productDatas.filter(item => item.name === 'ACH-Credit') || []
      achUKProductCountryList = achProductCountryList.length > 0 ? achProductCountryList.filter(item => {
        return item.country.includes(ACH_UK)
      }).map(item => item.country) : [];

      const rafCountryList = rafCountryListMap.get(item.id) !== undefined ? rafCountryListMap.get(item.id) : []

      const signupCountryList = rafCountryList.filter((item) => {
        return this.state.signupCountry.indexOf(item) !== -1
      })

      const nonSignupCountryList = rafCountryList.filter((item) => {
        return this.state.signupCountry.indexOf(item) === -1
      })

      // Simple sign scenario - BACS flow
      if (achUKProductCountryList.length > 0) {
        this.setState({
          isESignCountry: signupCountryList.length > 0 && nonSignupCountryList.length === 0 ? true : false,
          currentCaseid: item.id,
          bacsFlow: true,
          currentItem: item,
          showCancelEsignConfirmationModalDialog: true
        });
      } else { // E-sign scenario - Non-BACS flow
        this.setState({
          signupProductCountryListEsign: signupCountryList,
          isESignCountry: signupCountryList.length > 0 && nonSignupCountryList.length === 0 ? true : false,
          currentCaseid: item.id,
          bacsFlow: false,
          currentItem: item,
          showCancelEsignConfirmationModalDialog: true
        });
      }
      /* this.setState({
        currentCaseid: item.id,
        showCancelEsignConfirmationModalDialog: true
      }) */
    }
  }

  _checkboxHandler = (event) => {
    let _finalizeBtnStatuses = { ...this.state.finalizeBtnStatuses };
    event.target.name = event.target.name.replace('_', '');
    _finalizeBtnStatuses[event.target.name] = event.target.checked;
    this.setState({ finalizeBtnStatuses: _finalizeBtnStatuses });
  }

  checkFinalizedDate = (param) => {
    const releaseDateStr = "18 Nov '23"
    const releaseDate = new Date(releaseDateStr)
    const finalizeDateToCheck = new Date(param.finalizeDate)
    const checkDateFlag = finalizeDateToCheck < releaseDate
    return checkDateFlag
  }

  _ifContentDiv = (item, pageJson, index) => {
    let setFooterConent = [];
    let caseStatus = CASE_STATUS_LEVEL_LOOKUP_TABLE[item.statusKey]
    // if(item.signedDate !=='' && !this.props.customer){
    //if case status is urn:hsbc:cmb:gdocs:cases:taxonomies:status:awaitingActivation(Signed) or urn:hsbc:cmb:gdocs:cases:taxonomies:status:complete
    if (caseStatus >= 4 && caseStatus <= 5 && !this.props.customer) {
      setFooterConent.push(
        <div className={classnames({
          "gdoc-caseDocument-content": true,
          "block": this.props.caseMenu.isEditing
        })} key={item.id}>
          <div className="gdoc-caseDocument-contentBtn">
            <button id={`finalize_doc_btn${index}`} onClick={() => this._documentationHandler(item.id, 'signedDate', index)}
              className="">
              {this.translations(pageJson.button_detailsScanned.text)}
            </button>
          </div>
        </div>
      )
    }
    //else if(item.finalizeDate !=='' && item.signedDate === '' && !this.props.customer) {
    //if case status is urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationAwaitingSignature(finalized)
    else if (caseStatus === 3 && !this.props.customer) {
      const { cases } = this.props;

      setFooterConent.push(
        <div className={classnames({
          "gdoc-caseDocument-content": true,
          "block": this.props.caseMenu.isEditing
        })} key={item.id}>
          <div className="gdoc-caseDocument-contentBtn">
            {item.eSignStatus !== null && item.eSignStatus.overallStatus === 'in-progress' &&
              <button style={{ marginRight: '11px' }} id={`finalize_doc_btn${index}`} onClick={() => this._documentationHandler(item, 'cancelEsign', index)}>
                {this.translations(this.state.signatoryJsonModal && this.state.signatoryJsonModal.static_text_esignCancelPopup.cancelEsignButton)}
              </button>}
            {!this.checkFinalizedDate(item) &&
              <button style={{ marginRight: '10px' }} id={`finalize_doc_btn${index}`}
                onClick={() => this._documentationHandler(item, 'simpleSign', index)}
                className="">
                {this.translations(pageJson.button_sendtoSimplesign.text)}
              </button>
            }
            <button id={`finalize_doc_btn${index}`} onClick={() => this._documentationHandler(item.id, 'finalizeDate', index)}
              className="">
              {this.translations(pageJson.button_markSigned.text)}
            </button>
          </div>
        </div>
      )
    }
    //else if(item.documentGenerationDate !== '' && item.finalizeDate ==='' && item.signedDate === '') {
    //if case status is urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationDraft(drafted)

    // finalize button with check box

    else if (caseStatus === 2 && Object.keys(this.props.cases).length === 1) {
      setFooterConent.push(
        <div className={classnames({
          "gdoc-caseDocument-content": true,
          "block": this.props.caseMenu.isEditing
        })} key={item.id}>
          <div className="gdoc-caseDocument-contentDiv">
            <Checkbox name={item.id + '_'} isDocCheck={true} onChange={this._checkboxHandler} />
            <p>{this.translations(pageJson.checkbox_confirmation.text)}</p>
          </div>
          <div className="gdoc-caseDocument-contentBtn">
            <button id={`finalize_doc_btn${index}`} disabled={this.state.finalizeBtnStatuses[item.id] === undefined || this.state.finalizeBtnStatuses[item.id] === false}
              onClick={() => this._documentationHandler(item.id, 'generateDate', index)}
              className="">
              {this.translations(pageJson.button_finalise.text)}
            </button>
          </div>
        </div>
      )
    }
    return setFooterConent;
  }

  // Finalize document (old flow to finalize a single document in a single-entity case)
  // Handle documentation-path API call for single-entity finalize modal
  openFinalizeModalDialog = (caseid) => {
    this.setState({ caseDocumentationPaths: [] });
    if (this.props.isTbtEnabled === true) {
      eapiClient('/cases/documentation-path', {
        method: 'POST',
        timeout: 420000,
        data: JSON.stringify([caseid])
      })
        .then(({ data, status }) => {
          if (status === 200) {
            this.setState({
              caseDocumentationPaths: data.responseData || [],
              showFinalizeModalDialog: true,
              currentCaseid: caseid
            });
          }
        })
        .catch((error) => {
          consoleLog('Error in fetching documentation-path data', 'error', false, error);
          if (error.response && (error.response.status === 400 || error.response.status === 422)) {
            this.setState({ showFinalizeModalDialog: true, currentCaseid: caseid });
          }
        });
    } else {
      this.setState({ showFinalizeModalDialog: true, currentCaseid: caseid });
    }
  }

  openMarkedSignedModalDialog = (caseid) => {
    var currentCaseDocumentationData = this.getCurrentCaseDocumentationData(caseid);
    var scannedUploads = currentCaseDocumentationData.signedDocuments;
    this.setState({
      showMarkedModalDialog: true,
      currentCaseid: caseid,
      currentCaseDocumentationData,
      scannedUploads: scannedUploads ? scannedUploads : []
    });
  }

  toggleDialog = () => {
    let lastButtonClicked = this.state.lastButtonClicked
    console.log(lastButtonClicked);
    document.getElementById(lastButtonClicked).focus();
    this.setState({ showFinalizeModalDialog: false, showFinalizeDocumentsModalDialog: false, showSignatoryModalDialog: false });
  }

  toggleMarkedSignedDialog = () => {
    let lastButtonClicked = this.state.lastButtonClicked
    console.log(lastButtonClicked);
    document.getElementById(lastButtonClicked).focus();
    this.loadDocumentationPageState();
    this.setState({
      showMarkedModalDialog: false,
      scannedUploads: []
    });
  }

  /* Finalize GDocs Documents - Foreground Process */
  finalizeGDocsDocuments = (caseIds) => {
    return new Promise((resolve, reject) => {
      eapiClient("/cases/finalize-gdocs-documentation?isBgProcess=false", {
        method: 'POST',
        timeout: 420000,
        data: JSON.stringify({ caseIds, documentationPath: 'GDOCS' })
      })
        .then(() => {
          this.cancelFinalDocStatusPoll = setInterval(() => {
            eapiClient('/cases/poll-finalize-gdocs-draft', {
              noBlocking: true,
              method: 'POST',
              data: JSON.stringify({ caseIds })
            })
              .then(({ status }) => {
                if (status === 201) {
                  clearInterval(this.cancelFinalDocStatusPoll);
                  resolve();
                }
              })
              .catch((error) => {
                clearInterval(this.cancelFinalDocStatusPoll);
                reject(error);
              });
          }, 5000);
        })
        .catch(reject);
    });
  }

  /* Finalize TBT Documents - Foreground Process */
  finalizeTbtDocuments = (caseIds) => {
    return new Promise((resolve, reject) => {
      eapiClient("/cases/finalize-tbt-documentation?isBgProcess=false", {
        method: 'POST',
        timeout: 420000,
        data: JSON.stringify({ caseIds, documentationPath: 'TBT' })
      })
        .then(() => {
          this.cancelFinalTbtDocStatusPoll = setInterval(() => {
            eapiClient('/cases/poll-finalize-tbt-draft', {
              noBlocking: true,
              method: 'POST',
              data: JSON.stringify({ caseIds })
            })
              .then(({ status }) => {
                if (status === 201) {
                  clearInterval(this.cancelFinalTbtDocStatusPoll);
                  resolve();
                }
              })
              .catch((error) => {
                clearInterval(this.cancelFinalTbtDocStatusPoll);
                reject(error);
              });
          }, 5000);
        })
        .catch(reject);
    });
  }

  getCurrentCaseDocumentationData = (currentCaseid) => {
    return this.state.data.find(item => item.id === currentCaseid);
  }

  areArraysEqualById = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    const ids1 = arr1.map(obj => obj.id).sort();
    const ids2 = arr2.map(obj => obj.id).sort();
    for (let i = 0; i < ids1.length; i++) {
      if (ids1[i] !== ids2[i]) return false;
    }
    return true;
  }

  onMarkedSignedPopUp = () => {
    let payLoad = {};
    let apiUrl = "/cases/" + this.state.currentCaseid + "/signed";
    payLoad = this.state.basicDetails;
    delete payLoad.sentToSimpleSignDate;
    payLoad['scannedDocuments'] = this.scannedDocuments;
    if (this.state.currentCaseDocumentationData.oldStatusKey === CASE_COMPLETED && payLoad.statusKey !== AWAITING_SIGNATURE) {
      if (this.state.currentCaseDocumentationData.negotiation !== this.state.basicDetails.negotiation || !this.areArraysEqualById(this.state.scannedUploads, this.state.currentCaseDocumentationData.signedDocuments)) {
        payLoad['statusKey'] = CASE_COMPLETED;
      }
      if (this.state.currentCaseDocumentationData.negotiation === this.state.basicDetails.negotiation && this.areArraysEqualById(this.state.scannedUploads, this.state.currentCaseDocumentationData.signedDocuments)) {
        payLoad['statusKey'] = CASE_COMPLETED;
      }

    }
    delete payLoad.oldStatusKey;
    eapiClient(apiUrl, {
      method: 'POST',
      data: JSON.stringify(payLoad)
    })
      .then(({ data, status }) => {
        if (status === 200) {
          this.loadDocumentationPageState(() => {
            if (data.responseData.status === 'urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationAwaitingSignature') {
              this.props.disableTab(3);
            } else {
              this.props.enableTab(3);
            }

            this.setState({ showMarkedModalDialog: false });
          });
        }
      });
  }

  downloadDocuments = (data) => {
    eapiClient(`/cases/${data.id}/downloadDocument`, {
      method: 'GET',
      responseType: 'blob',
    }, { timeout: 420000 })
      .then((response, filename, mime) => {
        var blob = new Blob([response.data], { type: mime || 'application/octet-stream' });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // IE workaround for "HTML7007: One or more blob URLs were
          // revoked by closing the blob for which they were created.
          // These URLs will no longer resolve as the data backing
          // the URL has been freed."
          window.navigator.msSaveBlob(blob, `${data.entityName}_${data.caseId}_${moment(data.createdOn).format("HHmmss")}.pdf`);
        }
        else {
          var blobURL = window.URL.createObjectURL(blob);
          var tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', `${data.entityName}_${data.caseId}_${moment(data.createdOn).format("HHmmss")}.pdf`);

          // Safari thinks _blank anchor are pop ups. We only want to set _blank
          // target if the browser does not support the HTML5 download attribute.
          // This allows you to download files in desktop safari if pop up blocking
          // is enabled.
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
          }

          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
      });
  }

  downloadEsignDocuments = (data) => {
    eapiClient(`/cases/${data.id}/downloadDocument?docType=ALR`, {
      method: 'GET',
      responseType: 'blob',
    }, { timeout: 420000 })
      .then((response, filename, mime) => {
        var blob = new Blob([response.data], { type: mime || 'application/octet-stream' });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // IE workaround for "HTML7007: One or more blob URLs were
          // revoked by closing the blob for which they were created.
          // These URLs will no longer resolve as the data backing
          // the URL has been freed."
          window.navigator.msSaveBlob(blob, `AR_${data.entityName}_${data.caseId}.pdf`);
        }
        else {
          var blobURL = window.URL.createObjectURL(blob);
          var tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', `AR_${data.entityName}_${data.caseId}.pdf`);

          // Safari thinks _blank anchor are pop ups. We only want to set _blank
          // target if the browser does not support the HTML5 download attribute.
          // This allows you to download files in desktop safari if pop up blocking
          // is enabled.
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
          }

          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
      });
  }
  // E-sign modal
  //1. static text popup modal

  cancelESignModal = () => {
    this.setState({ showESignModalDialog: false });
  }
  _onSubmitESignModal = (bacsFlow) => {
    // api call for get signatory
    if (bacsFlow) {
      eapiClient("/cases/declaration/" + this.state.currentCaseid + "/signatory")
        .then(({ data }) => {
          this.setState({
            showSignatoryModalDialog: true,
            currentCaseid: this.state.currentCaseid,
            signatoryModalResponse: data,
            showESignModalDialog: false,
          });
        })
    } else {
      eapiClient("/cases/esign/declaration/" + this.state.currentCaseid + "/signatory")
        .then(({ data }) => {
          this.setState({
            showESignModalDialog: false,
            signatoryModalResponse: data,
            showESignSignatoryModalDialog: true
          });
        })
    }
  }


  //2. E-sign sidnatory popup modal

  cancelESignSignatoryModal = () => {
    this.setState({ showESignSignatoryModalDialog: false });
  }

  _onSubmitESignSignatoryModal = (param) => {
    let esignPayloadObj = {}
    let payloadSignersArr = []
    let payloadCcsArr = null

    if (this.state.signatoryModalResponse && this.state.signatoryModalResponse !== undefined && this.state.signatoryModalResponse['responseData']) {
      for (let i = 0; i < this.state.signatoryModalResponse['responseData'].length; i++) {
        let payloadObj = {};
        let phone = {};
        payloadObj.name = this.state.signatoryModalResponse['responseData'][i].firstName
        payloadObj.surName = this.state.signatoryModalResponse['responseData'][i].lastName
        payloadObj.emailAddress = param['signatoryEmail' + `${i + 1}`] ? param['signatoryEmail' + `${i + 1}`] : this.state.signatoryModalResponse['responseData'][i].emailAddress
        payloadObj.username = param['signatoryEmail' + `${i + 1}`] ? param['signatoryEmail' + `${i + 1}`] : this.state.signatoryModalResponse['responseData'][i].emailAddress
        payloadObj.role = 'SIGNER'
        payloadObj.order = param.approverEmail && param.esignApprover.officeTelephoneNumberEsign ? 2 : 1

        if (['+441481', '+441534', '+441624'].indexOf(param.esignSignatories[i].officeTelephoneNumberEsignCountryCode.name) !== -1) {
          phone.countryCode = '+44'
        } else {
          phone.countryCode = param.esignSignatories[i].officeTelephoneNumberEsignCountryCode.name
        }

        if (param.esignSignatories[i].officeTelephoneNumberEsignAreaCode) {
          phone.phoneNumber = param.esignSignatories[i].officeTelephoneNumberEsignAreaCode.name + param.esignSignatories[i].officeTelephoneNumberEsign
        }
        else {
          if (param.esignSignatories[i].officeTelephoneNumberEsignCountryCode.name === '+441481') {
            phone.phoneNumber = 1481 + param.esignSignatories[i].officeTelephoneNumberEsign
          } else if (param.esignSignatories[i].officeTelephoneNumberEsignCountryCode.name === '+441534') {
            phone.phoneNumber = 1534 + param.esignSignatories[i].officeTelephoneNumberEsign
          } else if (param.esignSignatories[i].officeTelephoneNumberEsignCountryCode.name === '+441624') {
            phone.phoneNumber = 1624 + param.esignSignatories[i].officeTelephoneNumberEsign
          } else {
            phone.phoneNumber = param.esignSignatories[i].officeTelephoneNumberEsign
          }
        }
        //phone.phoneNumber = param.esignSignatories[i].officeTelephoneNumberEsign
        payloadObj.phone = phone
        payloadSignersArr.push(payloadObj)
        esignPayloadObj.signers = payloadSignersArr
        esignPayloadObj.ccs = payloadCcsArr
      }

      if (param.showApproverCcSection === 'approver' && param.approverFirstName && param.approverLastName && param.approverEmail
        && param.esignApprover.officeTelephoneNumberEsignCountryCode
        // && (param.esignApprover.officeTelephoneNumberEsignCountryCode.name === '+1' && param.esignApprover.officeTelephoneNumberEsignAreaCode)
        && param.esignApprover.officeTelephoneNumberEsign) {
        let payloadObj = {};
        let phone = {};
        payloadObj.name = param.approverFirstName
        payloadObj.surName = param.approverLastName
        payloadObj.emailAddress = param.approverEmail
        payloadObj.username = param.approverEmail
        payloadObj.role = 'APPROVER'
        payloadObj.order = 1
        /* phone.countryCode = param.esignApprover.officeTelephoneNumberEsignCountryCode.name
        if (param.esignApprover.officeTelephoneNumberEsignAreaCode) {
          phone.phoneNumber = param.esignApprover.officeTelephoneNumberEsignAreaCode.name + param.esignApprover.officeTelephoneNumberEsign
        } else {
          phone.phoneNumber = param.esignApprover.officeTelephoneNumberEsign
        } */
        if (['+441481', '+441534', '+441624'].indexOf(param.esignApprover.officeTelephoneNumberEsignCountryCode.name) !== -1) {
          phone.countryCode = '+44'
        } else {
          phone.countryCode = param.esignApprover.officeTelephoneNumberEsignCountryCode.name
        }

        if (param.esignApprover.officeTelephoneNumberEsignAreaCode) {
          phone.phoneNumber = param.esignApprover.officeTelephoneNumberEsignAreaCode.name + param.esignApprover.officeTelephoneNumberEsign
        }
        else {
          if (param.esignApprover.officeTelephoneNumberEsignCountryCode.name === '+441481') {
            phone.phoneNumber = 1481 + param.esignApprover.officeTelephoneNumberEsign
          } else if (param.esignApprover.officeTelephoneNumberEsignCountryCode.name === '+441534') {
            phone.phoneNumber = 1534 + param.esignApprover.officeTelephoneNumberEsign
          } else if (param.esignApprover.officeTelephoneNumberEsignCountryCode.name === '+441624') {
            phone.phoneNumber = 1624 + param.esignApprover.officeTelephoneNumberEsign
          } else {
            phone.phoneNumber = param.esignApprover.officeTelephoneNumberEsign
          }
        }
        // phone.phoneNumber = param.esignApprover.officeTelephoneNumberEsign
        payloadObj.phone = phone
        payloadSignersArr.push(payloadObj)
        esignPayloadObj.signers = payloadSignersArr
        esignPayloadObj.ccs = payloadCcsArr
      }

      if (param.showApproverCcSection === 'cc' && param.ccEmail) {
        let payloadObj = {}
        payloadObj.emailAddress = param.ccEmail
        payloadCcsArr = [payloadObj]
        esignPayloadObj.ccs = payloadCcsArr
      }

      this.setState({ payloadObj: esignPayloadObj })
      this.setState({
        showESignSignatoryModalDialog: false,
        showESignConfirmationModalDialog: true
      });
    }
  }

  //3. Confirmation to E-sign modal

  cancelESignConfirmationModal = () => {
    this.setState({ showESignConfirmationModalDialog: false, showESignSignatoryModalDialog: true });
  }

  _onSubmitESignConfirmationModal = () => {
    // Hong Kong and Malaysia Linkless request param
    const countryNameIsoCodeMap = new Map(this.state.signupCountryObj && this.state.signupCountryObj.map(obj => [obj.name, (obj.isoCode === 'UK' || obj.isoCode === 'GBR') ? 'GB' : obj.isoCode]))
    const isoCodesArray = this.state.signupProductCountryListEsign && this.state.signupProductCountryListEsign.map(country => countryNameIsoCodeMap.get(country))
    const isoCodesSet = new Set(isoCodesArray)
    let linklessIsoCode = null
    if (isoCodesSet.has('HK')) {
      linklessIsoCode = 'HK'
    } else if (isoCodesSet.has('MY')) {
      linklessIsoCode = 'MY'
    } else {
      linklessIsoCode = isoCodesArray[0]
    }
    // API call for send payload data to e-sign
    eapiClient(`/cases/esign/declaration/${this.state.currentCaseid}/signatory/${linklessIsoCode}`, {
      method: 'POST',
      data: JSON.stringify(this.state.payloadObj)
    })
      .then(({ data, status }) => {
        this.props.blockUi();
        this.cancelDocStatusPoll = setInterval(() => {
          eapiClient(`/cases/esign/${this.state.currentCaseid}/poll-generate-esign`, {
            noBlocking: true,
            method: 'GET'
          })
            .then(({ data, status }) => {
              if (status === 201) {
                // cb();
                clearInterval(this.cancelDocStatusPoll);
                this.props.unBlockUi();
                // doc-status API call
                eapiClient("/cases/" + this.props.owningCase.caseId + "/doc-status", { timeout: 420000 })
                  .then(({ data }) => {
                    this.setState({ data: data.responseData.data }, () => { this.setState({ showSentForESignModal: true }) })
                    // this._renderContent()
                  })
              }
            })
            .catch(error => {
              clearInterval(this.cancelDocStatusPoll);
            });
        }, 5000);
      })
      .catch((error) => {
        console.log(error);
      })
    this.setState({ showESignConfirmationModalDialog: false, showESignSignatoryModalDialog: false });
  }

  //4. success/ error message popup modal

  // 5. Cancel e-signature confirmation modal and cancelled successfully modal

  cancelCancelESignConfirmationModal = () => {
    this.setState({ showCancelEsignConfirmationModalDialog: false });
  }

  _onSubmitCancelESignConfirmationModal = () => {
    const countryNameIsoCodeMap = new Map(this.state.signupCountryObj && this.state.signupCountryObj.map(obj => [obj.name, (obj.isoCode === 'UK' || obj.isoCode === 'GBR') ? 'GB' : obj.isoCode]))
    const isoCodesArray = this.state.signupProductCountryListEsign && this.state.signupProductCountryListEsign.map(country => countryNameIsoCodeMap.get(country))
    const isoCodesSet = new Set(isoCodesArray)
    let linklessIsoCode = null
    if (isoCodesSet.has('HK')) {
      linklessIsoCode = 'HK'
    } else if (isoCodesSet.has('MY')) {
      linklessIsoCode = 'MY'
    } else {
      linklessIsoCode = isoCodesArray[0]
    }
    // API call for cancel e-signature
    eapiClient(`/cases/esign/${this.state.currentCaseid}/cancelSignatory/${linklessIsoCode}`, {
      method: 'POST',
      timeout: 100000
    })
      .then(({ data, status }) => {
        if (status === 200) {
          // setState to close and open modals
          this.setState({ showCancelEsignConfirmationModalDialog: false, showEsignCanceledModalDialog: true });
          // doc-status API call
          eapiClient("/cases/" + this.props.owningCase.caseId + "/doc-status", { timeout: 420000 })
            .then(({ data }) => {
              this.setState({ data: data.responseData.data })
            })
        }
      })
  }

  closeEsignCanceledModalAction = () => {
    this.setState({ showEsignCanceledModalDialog: false })
  }

  ////////send to sign on modal///////////////

  openSignatoryModalDialog = (caseid) => {
    eapiClient("/cases/declaration/" + caseid + "/signatory")
      .then(({ data }) => {
        this.setState({
          showSignatoryModalDialog: true,
          currentCaseid: caseid,
          signatoryModalResponse: data
        });
      })

  }

  cancelSignatory = () => {
    this.setState({ showSignatoryModalDialog: false });
  }

  _onSubmitpop = (param) => {
    this.setState({ showSignatoryModalDialog: false, showSignatoryConfirmationModalDialog: true });
    let payloadArr = []
    if (this.state.signatoryModalResponse && this.state.signatoryModalResponse !== undefined && this.state.signatoryModalResponse['responseData']) {
      for (let i = 0; i < this.state.signatoryModalResponse['responseData'].length; i++) {
        let payloadObj = {};
        payloadObj.firstName = this.state.signatoryModalResponse['responseData'][i].firstName
        payloadObj.lastName = this.state.signatoryModalResponse['responseData'][i].lastName
        payloadObj.email = param['email' + `${i + 1}`] ? param['email' + `${i + 1}`] : this.state.signatoryModalResponse['responseData'][i].emailAddress
        payloadObj.phoneNumber = param['phone' + `${i + 1}`] ? param['phone' + `${i + 1}`] : this.state.signatoryModalResponse['responseData'][i].telephoneNumber
        // payloadObj.reference = i + 1
        payloadArr.push(payloadObj)
      }
      this.setState({ payloadObj: payloadArr })
    }
  }
  // single sign confirmation popup


  _onSubmitConfirmationPopup = () => {
    eapiClient(`/cases/declaration/${this.state.currentCaseid}/signatory`, {
      method: 'PUT',
      data: JSON.stringify(this.state.payloadObj)
    })
      .then(({ data, status }) => {
        eapiClient("/cases/" + this.props.owningCase.caseId + "/doc-status", { timeout: 420000 })
          .then(({ data }) => {
            this.setState({ data: data.responseData.data })
            this._renderContent()
            this.setState({ showSentForSimpleSignModal: true, responseReceived: data.responseStatus.serviceErrorCode === "" ? true : false })
          })
      })
      .catch((error) => {
        console.log(error);
        this.setState({ showSentForSimpleSignModal: true, responseReceived: false })
      })
    this.setState({ showSignatoryConfirmationModalDialog: false, showSignatoryModalDialog: false });
  }

  cancelSignatoryConfirmation = () => {
    this.setState({ showSignatoryConfirmationModalDialog: false, showSignatoryModalDialog: true });
  }

  cancelSentToESignAction = () => {
    this.setState({ showSentForSimpleSignModal: false });
  }
  closeSentToESignAction = () => {
    this.setState({ showSentForESignModal: false });
  }


  _renderContent() {
    let element = [];
    for (let i = 0; this.state.data && this.state.data.length > i; i++) {
      var caseSigned;
      var caseSignedDate;
      var caseSimpleSigned;
      var caseSimpleSignedDate = '';
      if (this.state.data[i].finalizeDate !== '' && this.state.data[i].signedDate === '') {
        caseSigned = this.translations(this.state.pageJson.button_finalise.name);
        caseSignedDate = this.state.data[i].finalizeDate;
      }
      else if (this.state.data[i].signedDate !== '') {
        caseSigned = this.translateWord(this.state.pageJson.documentation_pack_docPac.statusText)[2];
        caseSignedDate = this.state.data[i].signedDate;
      }
      else {
        caseSigned = this.translations(this.state.pageJson.documentation_pack_docPac.dateLabel);
        caseSignedDate = this.state.data[i].documentGenerationDate;
      }
      if (this.state.data[i].sentToSimpleSignDate !== '') {
        caseSimpleSigned = this.translations(this.state.pageJson.documentation_pack_docPac.sentForEsign);
        caseSimpleSignedDate = this.state.data[i].sentToSimpleSignDate;
      }
      element.push(
        <div className={classnames({
          "gdoc-caseDocument": true,
          "block": this.props.caseMenu.isEditing
        })} key={this.state.data[i].id}>
          <h5 className="gdoc-caseDocument-Heading gdocs-responsive-text">{this.state.data[i].entityName}</h5>
          <div className="gdoc-caseDocument-Details">
            <div className='casedocument-details-section'>
              <div className="gdocs-float-left icon icon-pdf pdfIcon" aria-label="Case Documentation PDF" role="img"></div>
              <div className="gdocs-float-left gdoc-caseDocument-link">
                <h4 className='caseDocListHead gdocs-responsive-text gdocs-float-left'>
                  {`${this.translations(this.state.darkTitleBarJson.static_text_darkTitleBar.case)} ${this.state.data[i].entityName}_${this.state.data[i].caseId}_${moment(this.state.data[i].createdOn).format("HHmmss")}`}
                  <span className="icon icon-chevron-right iconCenter" aria-hidden="true"></span>
                </h4>
                <div className="gdocs-clear-float"></div>
                {caseSignedDate !== "" && <div className='caseDocListDesc'>
                  {caseSigned} {caseSignedDate} | {this.state.data[i].signedDocuments && this.state.data[i].signedDocuments.length !== 0 ? `${this.state.data[i].signedDocuments.length} ${this.translations(this.state.pageJson.button_detailsScanned.actionText)}` : ''}
                </div>}
                {caseSimpleSignedDate !== "" && <div className='caseDocListDesc'>
                  {caseSimpleSigned} {caseSimpleSignedDate}
                </div>}

                <p className="gdocs-note-text">{this.translations(this.state.pageJson.documentation_pack_docPac.noteText)}</p>
                {this.state.data[i].status !== 'Documentation, draft'
                  ? <p className="gdocs-note-text">{this.translations(this.state.pageJson.documentation_pack_docPac.esignNoteText)}</p>
                  : <br />
                }
              </div>
            </div>
            <div className='download-section-container'>
              {this.state.data[i].eSignStatus !== null && (this.state.data[i].eSignStatus.overallStatus === 'completed' || this.state.data[i].eSignStatus.overallStatus === 'rejected' || this.state.data[i].eSignStatus.overallStatus === 'expired' || this.state.data[i].eSignStatus.overallStatus === 'canceled') &&
                <div className={classnames({
                  "gdocs-float-right": true,
                  "block": this.props.caseMenu.isEditing
                })} >
                  <div className="statusCaseDoc gdocs-float-left">
                    {this.translations(this.state.pageJson.documentation_pack_docPac.downloadAuditReport)}
                  </div>
                  <button aria-label="Download" style={{ background: "inherit", border: "none" }} onClick={this.downloadEsignDocuments.bind(this, this.state.data[i])}>
                    <i className="icon icon-download downloadIconCaseList gdocs-float-left" ref="setattr" dir="dir" ></i>
                  </button>
                  <div className="separatorCaseList gdocs-float-left"></div>
                </div>}
              <div className={classnames({
                "gdocs-float-right": true,
                "block": this.props.caseMenu.isEditing
              })} >
                <div className="statusCaseDoc gdocs-float-left">{this.state.data[i].status}</div>
                <button aria-label="Download" style={{ background: "inherit", border: "none" }} onClick={this.downloadDocuments.bind(this, this.state.data[i])}>
                  <i className="icon icon-download downloadIconCaseList gdocs-float-left" ref="setattr" dir="dir" ></i>
                </button>
              </div>
              <div className="gdocs-clear-float"></div>
            </div>
          </div>
          <div className="gdocs-clear-float"></div>
          {this._ifContentDiv(this.state.data[i], this.state.pageJson, i)}
        </div>
      );
    }
    return element;
  }

  doNotFinalize = () => {
    // var _finalizeBtnStatuses = {...this.state.finalizeBtnStatuses};
    // _finalizeBtnStatuses[this.state.currentCaseid] = false;
    // this.setState({
    //   finalizeBtnStatuses: _finalizeBtnStatuses,
    //   showFinalizeModalDialog: false
    // });
    this.setState({
      showFinalizeModalDialog: false,
      showFinalizeDocumentsModalDialog: false,
      caseIdsForFinalization: [],
      selectAllFinalizeFlag: false,
      isFinalizeConfirmationChecked: false
    });
  }

  showCIUserBanners = () => {
    return this.caseStatuses.some(_case => _case.statusKey === AWAITING_SIGNATURE);
  }

  showCustomerBanners = () => {
    return this.caseStatuses.some(_case => _case.statusKey === AWAITING_SIGNATURE);
  }

  onBannerClose = (bannerId) => {
    this.setState({ bannersVisibility: { ...this.state.bannersVisibility, [bannerId]: true } });
  }

  onFileUpload = (event) => {
    const formData = new FormData();
    formData.append('files', event.target.files[0]);

    eapiClient(`/cases/${this.state.currentCaseid}/uploadDocument`, {
      method: 'POST',
      headers: {
        'content-type': 'multipart/form-data'
      },
      timeout: 100000,
      data: formData
    })
      .then(({ data }) => {
        this.setState({ scannedUploads: data.responseData });
      });
  }

  onFileDelete = (file) => {
    eapiClient(`/cases/${this.state.currentCaseid}/document/${file.id}`, { method: 'DELETE' })
      .then(({ data }) => {
        this.setState({ scannedUploads: data.responseData });
      });
  }

  // Finalize documents (new flow to finalize all or selected documents in multi-entity cases)
  // Handle documentation-path API call for multi-entity finalize modal
  openFinalizeDocumentsModalDialog = () => {
    this.setState({
      caseIdsForFinalization: [],
      selectAllFinalizeFlag: false,
      isFinalizeConfirmationChecked: false,
      caseDocumentationPaths: []
    });
    if (this.props.isTbtEnabled === true) {
      eapiClient('/cases/documentation-path', {
        method: 'POST',
        timeout: 420000,
        data: JSON.stringify(Object.keys(this.props.cases))
      })
        .then(({ data, status }) => {
          if (status === 200) {
            this.setState({
              caseDocumentationPaths: data.responseData || [],
              showFinalizeDocumentsModalDialog: true
            });
          }
        })
        .catch((error) => {
          consoleLog('Error in fetching documentation-path data', 'error', false, error);
          if (error.response && (error.response.status === 400 || error.response.status === 422)) {
            this.setState({ showFinalizeDocumentsModalDialog: true });
          }
        });
    } else {
      this.setState({ showFinalizeDocumentsModalDialog: true });
    }
  }

  _casesSelectedForFinalizeMultiEntity = (event) => {
    if (this.state.selectAllFinalizeFlag && !event.target.checked) {
      let caseIdsForFinalization = [...this.state.caseIdsForFinalization];
      caseIdsForFinalization.remove(event.target.name);
      this.setState({ caseIdsForFinalization });
      this.setState({ selectAllFinalizeFlag: false })
    }
    else {
      let caseIdsForFinalization = [...this.state.caseIdsForFinalization];
      if (event.target.checked && !caseIdsForFinalization.includes(event.target.name)) {
        caseIdsForFinalization.push(event.target.name);
      } else {
        caseIdsForFinalization.remove(event.target.name);
      }
      this.setState({ caseIdsForFinalization });
    }
  }

  _selectAllCasesForFinalizeMultiEntity = (event) => {
    const caseIds = Object.keys(this.props.cases);
    let caseIdsForFinalization = [...this.state.caseIdsForFinalization];
    if (event.target.checked) {
      caseIdsForFinalization = caseIds.filter(caseId => {
        return (this.props.cases[caseId].status === DOCUMENTATION_DRAFT)
      })
      this.setState({ selectAllFinalizeFlag: true })
    } else {
      caseIdsForFinalization = []
      this.setState({ selectAllFinalizeFlag: false })
    }
    this.setState({ caseIdsForFinalization });
  }

  _finalizeConfirmationCheckboxHandler = (event) => {
    this.setState({ isFinalizeConfirmationChecked: event.target.checked });
  }

  /* Splits the selected case ids into TBT and GDOCS groups based on per-entity/case documentation path */
  segregateSelectedCaseIdsByDocumentationPath = (selectedCaseIds) => {
    const isTbtByCaseId = this.state.caseDocumentationPaths.reduce((acc, item) => {
      acc[item.caseId] = item.isTbt;
      return acc;
    }, {});

    const tbtCaseIds = [];
    const gdocsCaseIds = [];

    selectedCaseIds.forEach((caseId) => {
      if (isTbtByCaseId[caseId] === true) {
        tbtCaseIds.push(caseId);
      } else {
        gdocsCaseIds.push(caseId);   // default/fallback stays GDOCS
      }
    });

    return { tbtCaseIds, gdocsCaseIds };
  }

  /* Reloads cases and documentation page state once finalization has completed */
  refreshDocumentationPage = () => {
    const singleEntityCaseId = Object.keys(this.props.cases)[0];
    eapiClient('/cases/' + singleEntityCaseId + '/allcases?status=true', { timeout: 420000 })
      .then(({ data }) => {
        this.props.setCases(data.responseData);
        this._renderContent();
        this.loadDocumentationPageState(() => {
          this.props.unBlockUi();
        });
      })
      .catch((error) => {
        this.props.unBlockUi();
        consoleLog('Error in refreshing documentation page', 'error', false, error);
      });
  }

  /* Finalize GDocs Documents - Background Process */
  finalizeGDocsDocumentsBgProcess = (caseIds) => {
    return eapiClient("/cases/finalize-gdocs-documentation?isBgProcess=true", {
      method: 'POST',
      timeout: 100000,
      data: JSON.stringify({ caseIds, documentationPath: 'GDOCS' })
    });
  }

  /* Finalize TBT Documents - Background Process */
  finalizeTbtDocumentsBgProcess = (caseIds) => {
    return eapiClient("/cases/finalize-tbt-documentation?isBgProcess=true", {
      method: 'POST',
      timeout: 100000,
      data: JSON.stringify({ caseIds, documentationPath: 'TBT' })
    });
  }

  _handleSingleEntityFinalizeClick = () => {
    const selectedCaseIds = [this.state.currentCaseid];
    const { tbtCaseIds } = this.segregateSelectedCaseIdsByDocumentationPath(selectedCaseIds);

    this.setState({ showFinalizeModalDialog: false });
    this.props.blockUi();

    const finalizationTask = tbtCaseIds.length > 0
      ? this.finalizeTbtDocuments(selectedCaseIds)
      : this.finalizeGDocsDocuments(selectedCaseIds);

    finalizationTask
      .then(() => {
        this.refreshDocumentationPage();
      })
      .catch((error) => {
        this.props.unBlockUi();
        consoleLog('Error in documents finalization', 'error', false, error);
      });
  }

  _handleModalFinalizeDocumentsClick = () => {
    const selectedCaseIds = [...this.state.caseIdsForFinalization];
    const { tbtCaseIds, gdocsCaseIds } = this.segregateSelectedCaseIdsByDocumentationPath(selectedCaseIds);

    this.doNotFinalize(); // reset show modal and other initial states
    this.props.blockUi();

    const casesArray = selectedCaseIds.map(caseId => this.props.cases[caseId]);
    const glsProductsArray = casesArray.reduce((acc, caseDetail) => {
      const glsProduct = caseDetail && caseDetail.productDatas && caseDetail.productDatas.find(data => data.name === 'GLS');
      if (glsProduct) {
        acc.push(glsProduct);
      }
      return acc;
    }, []);

    const hasGlsAndMultipleCases = glsProductsArray.length > 0 && selectedCaseIds.length > 1;
    const bgProcessThreshold = hasGlsAndMultipleCases ? 10 : 15;
    const shouldRunInBackground = Object.values(this.props.cases).length > 0 && selectedCaseIds.length >= bgProcessThreshold;

    const finalizationTasks = [];

    if (tbtCaseIds.length > 0) {
      finalizationTasks.push(
        shouldRunInBackground
          ? this.finalizeTbtDocumentsBgProcess(tbtCaseIds)
          : this.finalizeTbtDocuments(tbtCaseIds)
      );
    }

    if (gdocsCaseIds.length > 0) {
      finalizationTasks.push(
        shouldRunInBackground
          ? this.finalizeGDocsDocumentsBgProcess(gdocsCaseIds)
          : this.finalizeGDocsDocuments(gdocsCaseIds)
      );
    }

    if (finalizationTasks.length === 0) {
      this.props.unBlockUi();
      return;
    }

    Promise.all(finalizationTasks)
      .then(() => {
        if (shouldRunInBackground) {
          this.props.unBlockUi();
          this.setState({ showFinalizeBgProcessModal: true });
        } else {
          this.refreshDocumentationPage();
        }
      })
      .catch((error) => {
        this.props.unBlockUi();
        consoleLog('Error in documents finalization', 'error', false, error);
      });
  }

  redirectToCaseList = () => {
    this.setState({ showFinalizeBgProcessModal: false });
    this.props.history.push('/case-list');
  }

  render() {
    let documentationjsx = "";
    let bannersJsx = [];
    let customerBanner = '';
    const caseStatus = CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.owningCase.status];
    const areAllCasesNotDraft = Object.keys(this.props.cases).every(caseId => this.props.cases[caseId].status !== DOCUMENTATION_DRAFT);

    if (this.props.customer && caseStatus < 3) {
      customerBanner = (<Banner
        bannerType="primary"
        actionText="close"
        bannerId="ci-customer-banner"
        actionCallback={this.onBannerClose}
        hide={this.state.bannersVisibility['ci-customer-banner']}
      >
        {this.state.pageJson !== undefined ? this.translations(this.state.pageJson.notification_CustomerDocumentationNotification.message) : ""}
      </Banner>)
    }
    if (this.props.userRole.value === ROLES["ADMIN"] || this.props.userRole.value === ROLES["CASE_WORKER"]) {
      if (this.showCIUserBanners()) {
        bannersJsx.push(
          <Banner key="ci-user-banner-1" bannerId="ci-user-banner-1" bannerType="primary" actionText="Close" actionCallback={this.onBannerClose} hide={this.state.bannersVisibility['ci-user-banner-1']}>
            {this.state.pageJson !== undefined ? this.translations(this.state.pageJson.notification_draftNotification.text) : ""}
          </Banner>
        );
      }
    } else {
      if (this.showCustomerBanners()) {
        bannersJsx.push(
          <Banner key="customer-banner-1" bannerId="customer-banner-1" bannerType="primary" actionText="Close" actionCallback={this.onBannerClose} hide={this.state.bannersVisibility['customer-banner-1']}>
            {this.state.pageJson !== undefined ? this.translations(this.state.pageJson.notification_finalisedNotification.message) : ""}
          </Banner>
        );

        bannersJsx.push(
          <Banner key="customer-banner-2" bannerId="customer-banner-2" bannerType="primary" actionText="Close" actionCallback={this.onBannerClose} hide={this.state.bannersVisibility['customer-banner-2']}>
            {this.state.pageJson !== undefined ? this.translations(this.state.pageJson.notification_supportingDocsNotification.message) : ""} <Link
              to={{
                pathname: `/case-body/supporting-doc/${this.props.owningCase.caseId}`,
                state: { Urn: this.props.owningCase.caseId }
              }}> {this.state.pageJson !== undefined ? this.translations(this.state.pageJson.notification_supportingDocsNotification.text) : ""}
            </Link>
          </Banner>
        );
      }
    }

    if (this.state.pageJson === undefined || this.state.formJson === undefined || this.state.pageJsonModal === undefined || this.state.darkTitleBarJson === undefined || this.state.signatoryJsonModal === undefined || this.state.signatoryConfirmationJsonModal === undefined || this.state.sentForEsignModalDetails === undefined || this.state.sentForEsignNegativeMsg === undefined) {
      documentationjsx = (<span style={{ fontSize: "1.5rem" }} role='status'>Loading...</span>);
    } else {
      documentationjsx = (<div>
        {!this.props.customer ?
          <Banner
            bannerType="primary"
            actionText={this.state.pageJson !== undefined ? Translations(this.state.pageJson.notification_StaffandCustomerNotification.closeText, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
            bannerId="ci-customer-banner"
            actionCallback={this.onBannerClose}
            hide={this.state.bannersVisibility['ci-customer-banner']}
          >
            {this.state.pageJson !== undefined ? Translations(this.state.pageJson.notification_StaffandCustomerNotification.text, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
          </Banner> : ''
        }

        {Object.keys(this.props.cases).length > 1 ?
          <div className='finalize-docs-btn-section'>
            <button
              className='finalize-request-btn'
              id='finalize-request-btn'
              onClick={this.openFinalizeDocumentsModalDialog}
              disabled={areAllCasesNotDraft}
            // disabled={this.props.caseMenu.isEditing}
            >
              <span className='gdocs-btn-with-icon_flex'>
                <i className='icon icon-pdf gdocs-valign-bottom fontsize24 gdocs-pright-10' aria-hidden='true'></i>
                Finalise documents
                {/* {this.translations(this.state.pageJson.button_finalise.text)} */}
              </span>
            </button>
          </div> : null}

        {this._renderContent()}

        <FinalizeModal
          showDialog={this.state.showFinalizeModalDialog}
          {...this.state.pageJsonModal}
          toggleDialog={this.toggleDialog}
          doNotFinalize={this.doNotFinalize}
          _onFinalizedpop={this._handleSingleEntityFinalizeClick}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <FinalizeDocumentsModal
          showDialog={this.state.showFinalizeDocumentsModalDialog}
          {...this.state.pageJsonModal}
          toggleDialog={this.doNotFinalize}
          cases={this.props.cases || []} // From Redux store
          casesSelectedForFinalizeMultiEntity={this._casesSelectedForFinalizeMultiEntity}
          selectAllCasesForFinalizeMultiEntity={this._selectAllCasesForFinalizeMultiEntity}
          selectAllFinalizeFlag={this.state.selectAllFinalizeFlag}
          finalizeConfirmationCheckboxHandler={this._finalizeConfirmationCheckboxHandler}
          finalizeConfirmationText={this.state.pageJson.checkbox_confirmation.text}
          enableFinalizeBtn={this.state.caseIdsForFinalization}
          isFinalizeConfirmationChecked={this.state.isFinalizeConfirmationChecked}
          doNotFinalize={this.doNotFinalize}
          handleModalFinalizeClick={this._handleModalFinalizeDocumentsClick}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <FinalizeBgProcessModal
          showDialog={this.state.showFinalizeBgProcessModal}
          {...this.state.pageJsonModal}
          toggleDialog={this.redirectToCaseList}
          bsClass="finalize-bg-process-modal-content"
          _onOk={this.redirectToCaseList}
          translations={(word) => this.translations(word)}
        />

        <MarkedSignedModal showDialog={this.state.showMarkedModalDialog}
          {...this.state.formJson}
          toggleDialog={this.toggleMarkedSignedDialog}
          _onMarkedSignedPopUp={this.onMarkedSignedPopUp}
          _renderForm={this.renderMarkedpopupFormGroup()}
          history={this.props.history}
          currentCase={this.props.cases[this.state.currentCaseid]}
          btntext={this.state.formJson.button_saveChanges.name}
          whiteBtn={this.state.formJson.button_cancel.text}
          onFileUpload={this.onFileUpload}
          scannedUploads={this.state.scannedUploads}
          onFileDelete={this.onFileDelete}
          bsClass="gdocs-mark-signed-modal-content"
          translations={(word) => this.translations(word)}
        />

        <SignatoryModal
          signatoryModalResponse={this.state.signatoryModalResponse}
          showDialog={this.state.showSignatoryModalDialog}
          {...this.state.signatoryJsonModal}
          pageJson={this.state.pageJson}
          toggleDialog={this.toggleDialog}
          _onCanceldpop={this.cancelSignatory}
          _onSubmitpop={(param) => this._onSubmitpop(param)}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <SignatoryConfirmationModal
          showDialog={this.state.showSignatoryConfirmationModalDialog}
          {...this.state.signatoryConfirmationJsonModal}
          toggleDialog={this.cancelSignatoryConfirmation}
          _onCanceldpop={this.cancelSignatoryConfirmation}
          _onSubmitpop={this._onSubmitConfirmationPopup}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <SentToSimpleSignModal
          showDialog={this.state.showSentForSimpleSignModal}
          responseReceived={this.state.responseReceived}
          sentForEsignModalDetails={this.state.sentForEsignModalDetails}
          sentForEsignNegativeMsg={this.state.sentForEsignNegativeMsg}
          toggleDialog={this.cancelSentToESignAction}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <ESignModal
          showDialog={this.state.showESignModalDialog}
          {...this.state.signatoryJsonModal}
          pageJson={this.state.pageJson}
          toggleDialog={this.cancelESignModal}
          _onCanceldpop={this.cancelESignModal}
          _onSubmitpop={(flow) => this._onSubmitESignModal(flow)}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
          isESignCountry={this.state.isESignCountry}
          bacsFlow={this.state.bacsFlow}
          item={this.state.currentItem}
        />

        <ESignSignatoryModal
          signatoryModalResponse={this.state.signatoryModalResponse}
          showDialog={this.state.showESignSignatoryModalDialog}
          {...this.state.signatoryJsonModal}
          pageJson={this.state.pageJson}
          toggleDialog={this.cancelESignSignatoryModal}
          _onSubmitpop={(param) => this._onSubmitESignSignatoryModal(param)}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
          telephoneCountryCodes={this.state.telephoneCountryCodes}
          telephoneAreaCodes={this.state.telephoneAreaCodes}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          onBannerClose={this.onBannerClose}
          bannersVisibility={this.state.bannersVisibility}
        />

        <ESignConfirmationModal
          showDialog={this.state.showESignConfirmationModalDialog}
          {...this.state.signatoryConfirmationJsonModal}
          toggleDialog={this.cancelESignConfirmationModal}
          _onSubmitpop={this._onSubmitESignConfirmationModal}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <SentToESignModal
          showDialog={this.state.showSentForESignModal}
          {...this.state.signatoryConfirmationJsonModal}
          docStatusData={this.state.data}
          currentCaseId={this.state.currentCaseid}
          sentForEsignModalDetails={this.state.sentForEsignModalDetails}
          sentForEsignNegativeMsg={this.state.sentForEsignNegativeMsg}
          toggleDialog={this.closeSentToESignAction}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <CancelESignConfirmationModal
          showDialog={this.state.showCancelEsignConfirmationModalDialog}
          {...this.state.signatoryConfirmationJsonModal}
          eSignCancelPopup={this.state.signatoryJsonModal}
          toggleDialog={this.cancelCancelESignConfirmationModal}
          _onSubmitpop={this._onSubmitCancelESignConfirmationModal}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />

        <EsignCanceledModal
          showDialog={this.state.showEsignCanceledModalDialog}
          eSignCancelPopup={this.state.signatoryJsonModal}
          okButtonText={this.state.sentForEsignModalDetails.OkbuttonText}
          toggleDialog={this.closeEsignCanceledModalAction}
          bsClass="gdocs-finalize-doc-modal-content"
          translations={(word) => this.translations(word)}
        />
      </div>
      )
    }

    return ((this.state.pageJson !== undefined) ?
      <div className="gdoc-caseDocument-container">
        {customerBanner}
        {bannersJsx}
        {documentationjsx}
      </div>
      : '');
  }

  componentWillUnmount() {
    clearInterval(this.cancelFinalDocStatusPoll);
    clearInterval(this.cancelFinalTbtDocStatusPoll);
  }
}

const ESignModal = (props) => {
  return (
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      {/* <ModalHeader title={props.translations(props.static_text_esignPopup.title)} /> */}
      <ModalBody>
        <p>{props.translations(props.static_text_esignPopup.text1)}</p>
        <p>{props.translations(props.static_text_esignPopup.text2)}</p>
        <p>{props.translations(props.static_text_esignPopup.text3)}</p>
        <p>{props.translations(props.static_text_esignPopup.text4)}</p>
        <p>{props.translations(props.static_text_esignPopup.text5)}</p>
        <p>{props.translations(props.static_text_esignPopup.text6)}</p>
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-default" onClick={props._onCanceldpop}>{props.translations(props.static_text_esignPopup.esignPopupCancelButtonText)}</button>
        <button
          className="gdocs-btn-primary"
          disabled={(!props.isESignCountry) || (props.item.eSignStatus !== null && (props.item.eSignStatus.overallStatus !== 'failed' && props.item.eSignStatus.overallStatus !== 'rejected' && props.item.eSignStatus.overallStatus !== 'expired' && props.item.eSignStatus.overallStatus !== 'canceled'))}
          onClick={() => props._onSubmitpop(props.bacsFlow)}
        >
          {props.translations(props.static_text_esignPopup.esignPopupSubmitButtonText)}
        </button>
      </ModalFooter >
    </Modal >
  );
}

const ESignSignatoryModal = (props) => {
  // Initializing state object's properties - esignSignatories (array of objects) as [] and esignApprover (single object) as {}
  const [state, setState] = useState({
    isEmailValid1: true, isEmailValid2: true, isEmailValid3: true, isEmailValid4: true,
    isSignatoryPhoneValid1: true, isSignatoryPhoneValid2: true, isSignatoryPhoneValid3: true, isSignatoryPhoneValid4: true,
    isApproverFirstNameValid: true, isApproverLastNameValid: true, isApproverEmailValid: true, isApproverPhoneValid: true, isCcEmailValid: true,
    esignSignatories: [], esignApprover: {},
    showApproverCcSection: 'no'
  })

  const initialState = {
    isEmailValid1: true, isEmailValid2: true, isEmailValid3: true, isEmailValid4: true,
    isSignatoryPhoneValid1: true, isSignatoryPhoneValid2: true, isSignatoryPhoneValid3: true, isSignatoryPhoneValid4: true,
    esignSignatories: [], esignApprover: {},
    signatoryEmail1: null, signatoryEmail2: null, signatoryEmail3: null, signatoryEmail4: null,
    errorMsgEmail1: null, errorMsgEmail2: null, errorMsgEmail3: null, errorMsgEmail4: null,
    errorMsgSignatoryPhone1: null, errorMsgSignatoryPhone2: null, errorMsgSignatoryPhone3: null, errorMsgSignatoryPhone4: null,
    approverFirstName: '', approverLastName: '', approverEmail: '',
    isApproverFirstNameValid: true, isApproverLastNameValid: true, isApproverEmailValid: true, isApproverPhoneValid: true,
    errorMsgApproverFirstName: null, errorMsgApproverLastName: null, errorMsgApproverEmail: null, errorMsgApproverPhone: null,
    ccEmail: '', isCcEmailValid: true, errorMsgCcEmail: null,
    showApproverCcSection: 'no'
  }

  // useEffect with showDialog in the dependency array - state will be cleared whenever the component updates (modal is closed)
  useEffect(() => {
    if (!props.showDialog) {
      setState(initialState)
      // setState({ esignSignatories: [], esignApprover: {} })
    }
  }, [props.showDialog]);

  const handleEmailChange = (event, index, email) => {
    const value = event.target.value;
    const name = event.target.name;
    const emailPattern = /^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{1,}))$/

    setState({
      ...state,
      // esignApprover: { [name]: value },
      [name]: value,
      [`isEmailValid${index}`]: emailPattern.test(value),
      [`errorMsgEmail${index}`]: value !== "" && emailPattern.test(value) ? "" : "Please enter a valid email address"
    })
  }

  const handleApproverNameEmailChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    const emailRegex = /^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{1,}))$/
    const nameRegex = /[A-Za-z]/
    let isValid = true
    let errorMsg = ''

    if (name === 'approverFirstName') {
      isValid = nameRegex.test(value);
      errorMsg = value !== '' && isValid ? '' : 'Please enter the first name'
      setState({
        ...state,
        [name]: value,
        isApproverFirstNameValid: isValid,
        errorMsgApproverFirstName: errorMsg
      })
    } else if (name === 'approverLastName') {
      isValid = nameRegex.test(value);
      errorMsg = value !== '' && isValid ? '' : 'Please enter the last name'
      setState({
        ...state,
        [name]: value,
        isApproverLastNameValid: isValid,
        errorMsgApproverLastName: errorMsg
      })
    } else if (name === 'approverEmail') {
      isValid = emailRegex.test(value);
      errorMsg = value !== '' && isValid ? '' : 'Please enter a valid email address'
      setState({
        ...state,
        [name]: value,
        isApproverEmailValid: isValid,
        errorMsgApproverEmail: errorMsg
      })
    } else if (name === 'ccEmail') {
      isValid = emailRegex.test(value);
      errorMsg = value !== '' && isValid ? '' : 'Please enter a valid email address'
      setState({
        ...state,
        [name]: value,
        isCcEmailValid: isValid,
        errorMsgCcEmail: errorMsg
      })
    }
  }

  const handleEsignPhoneChange = (event, signatoryIndex) => {
    const { name, value } = event.target
    const phoneRegex = /\d/;
    const esignSignatories = props.signatoryModalResponse['responseData'].filter(item => item.contactType === "Declaration Signatory")
    const esignSignatoryObject = Array.isArray(esignSignatories) && esignSignatories.length ? esignSignatories[signatoryIndex] : {}
    const codes = name.includes("CountryCode") ? props.telephoneCountryCodes : props.telephoneAreaCodes
    if (!isEmptyObject(esignSignatoryObject)) {
      if (name.includes("CountryCode") && value !== "+1" && esignSignatoryObject[name.replace("CountryCode", "AreaCode")]) {
        esignSignatoryObject[name.replace("CountryCode", "AreaCode")] = undefined
      }
      esignSignatoryObject[name] = (name.includes("CountryCode") || name.includes("AreaCode")) ? codes.find(code => code.name === value) : value
      esignSignatories[signatoryIndex] = esignSignatoryObject
      setState({
        ...state,
        esignSignatories: esignSignatories,
        [`isSignatoryPhoneValid${signatoryIndex + 1}`]: phoneRegex.test(esignSignatories[signatoryIndex].officeTelephoneNumberEsign),
        [`errorMsgSignatoryPhone${signatoryIndex + 1}`]: (esignSignatories[signatoryIndex].officeTelephoneNumberEsign !== "" && phoneRegex.test(esignSignatories[signatoryIndex].officeTelephoneNumberEsign)) ? "" : "Please enter the mobile number" // Can implement optional chaining here
      });
    }
  }

  const handleEsignApproverPhoneChange = (event) => {
    const { name, value } = event.target
    const phoneRegex = /\d/;
    let esignApprover = state.esignApprover
    const codes = name.includes("CountryCode") ? props.telephoneCountryCodes : props.telephoneAreaCodes
    if (name.includes("CountryCode") && value !== "+1") {
      esignApprover[name.replace("CountryCode", "AreaCode")] = undefined
    }
    esignApprover[name] = (name.includes("CountryCode") || name.includes("AreaCode")) ? codes.find(code => code.name === value) : value
    setState({
      ...state,
      esignApprover: esignApprover,
      isApproverPhoneValid: phoneRegex.test(esignApprover.officeTelephoneNumberEsign),
      errorMsgApproverPhone: (esignApprover.officeTelephoneNumberEsign !== "" && phoneRegex.test(esignApprover.officeTelephoneNumberEsign)) ? "" : "Please enter the mobile number"
    })
  }

  const getTelephoneKey = (prefix = '', postfix = '') => {
    return prefix + postfix
  }

  const handleSubmitDisable = () => {
    const responseDataLength = props.signatoryModalResponse && props.signatoryModalResponse['responseData'].length;
    const countryCodeName = getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name, props.guidedropdownlist_CountryCode.name);
    const areaCodeName = getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name, props.guidedropdownlist_AreaCode.name);
    const phoneName = props.guidetextbox_officeTelephoneNumberEsign.name;

    let areAllSignatoryFieldsFilled = false;
    let areAllApproverFieldsFilled = false;
    let areAllCcFieldsFilled = false;

    let signatoryFilledStatus = []

    for (let i = 0; i < responseDataLength; i++) {
      let signatoryEmail = state['signatoryEmail' + `${i + 1}`] ? state['signatoryEmail' + `${i + 1}`] : (state.esignSignatories[i] && state.esignSignatories[i].emailAddress)
      let countryCode = state['countryCode' + `${i + 1}`] ? state['countryCode' + `${i + 1}`] : (state.esignSignatories[i] && state.esignSignatories[i][countryCodeName] && state.esignSignatories[i][countryCodeName].name)
      let areaCode = state['areaCode' + `${i + 1}`] ? state['areaCode' + `${i + 1}`] : (state.esignSignatories[i] && state.esignSignatories[i][areaCodeName] && state.esignSignatories[i][areaCodeName].name)
      let phone = state['phone' + `${i + 1}`] ? state['phone' + `${i + 1}`] : (state.esignSignatories[i] && state.esignSignatories[i][phoneName])
      let emailError = state['errorMsgEmail' + `${i + 1}`]
      let signatoryPhoneError = state['errorMsgSignatoryPhone' + `${i + 1}`]
      areAllSignatoryFieldsFilled = (!signatoryEmail || !countryCode || (countryCode === '+1' && !areaCode) || !phone || emailError === "Please enter a valid email address" || signatoryPhoneError === "Please enter the mobile number") ? false : true
      signatoryFilledStatus.push(areAllSignatoryFieldsFilled);
    }
    if (signatoryFilledStatus.every(value => value === true)) {
      areAllSignatoryFieldsFilled = true
    } else {
      areAllSignatoryFieldsFilled = false
    }

    // Can comment out the if statement, now that we have the showApproverCcSection logic
    if (state.approverEmail || state.approverFirstName || state.approverLastName || state.esignApprover[countryCodeName] || state.esignApprover[areaCodeName] || state.esignApprover[phoneName]) {
      let approverFirstName = state.approverFirstName ? state.approverFirstName : null
      let approverLastName = state.approverLastName ? state.approverLastName : null
      let approverEmail = state.approverEmail ? state.approverEmail : (state.esignApprover && state.esignApprover.emailAddress)
      let approverCountryCode = state.approverCountryCode ? state.approverCountryCode : (state.esignApprover && state.esignApprover[countryCodeName] && state.esignApprover[countryCodeName].name)
      let approverAreaCode = state.approverAreaCode ? state.approverAreaCode : (state.esignApprover && state.esignApprover[areaCodeName] && state.esignApprover[areaCodeName].name)
      let approverPhone = state.approverPhone ? state.approverPhone : (state.esignApprover && state.esignApprover[phoneName])
      let approverFirstNameError = state.errorMsgApproverFirstName
      let approverLastNameError = state.errorMsgApproverLastName
      let approverEmailError = state.errorMsgApproverEmail
      let approverPhoneError = state.errorMsgApproverPhone
      areAllApproverFieldsFilled = !approverFirstName || !approverLastName || !approverEmail || !approverCountryCode || (approverCountryCode === '+1' && !approverAreaCode) || !approverPhone || approverFirstNameError !== '' || approverLastNameError !== '' || approverEmailError === "Please enter a valid email address" || approverPhoneError === "Please enter the mobile number" ? false : true
    }

    let ccEmail = state.ccEmail ? state.ccEmail : null;
    let ccEmailError = state.errorMsgCcEmail
    areAllCcFieldsFilled = !ccEmail || ccEmailError === "Please enter a valid email address" ? false : true;

    // const isEnabled = state.showApproverCcSection === true ? areAllSignatoryFieldsFilled && areAllApproverFieldsFilled : areAllSignatoryFieldsFilled
    const isEnabled = state.showApproverCcSection === 'approver' ? areAllSignatoryFieldsFilled && areAllApproverFieldsFilled : state.showApproverCcSection === 'cc' ? areAllSignatoryFieldsFilled && areAllCcFieldsFilled : areAllSignatoryFieldsFilled
    return !isEnabled
  }

  const renderLabel = (param, index) => {
    const contactType = param.contactType
    const firstName = param.firstName
    if (contactType === "Declaration Signatory") {
      index++;
      return (`${contactType} ${index}`)
    }
  }

  /* const handleEsignSignatoryModalClose = () => {
    setState(initialState);
    // props.setShowESignSignatoryModalDialog(false)
    props.toggleDialog()
  } */

  const handleApproverSectionRadioButton = (event) => {
    let value;
    if (typeof event === 'object') {
      //This is the case for radio button having more than two options
      if (event.value === "true" || event.value === "false") {
        value = JSON.parse(event.value);
      } else {
        value = {
          name: event.name,
          value: event.value
        }
      }
    } else {
      value = event;
    }
    setState({
      ...state,
      esignApprover: {},
      approverFirstName: '', approverLastName: '', approverEmail: '',
      isApproverFirstNameValid: true, isApproverLastNameValid: true, isApproverEmailValid: true, isApproverPhoneValid: true,
      errorMsgApproverFirstName: null, errorMsgApproverLastName: null, errorMsgApproverEmail: null, errorMsgApproverPhone: null,
      ccEmail: '', isCcEmailValid: true, errorMsgCcEmail: null,
      showApproverCcSection: (value.value === 'no' ? 'no' : value.value === 'approver' ? 'approver' : 'cc')
    })
  }

  const translateWordForRadio = (text) => {
    var currentText = Translations(text, props.lang, props.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentText);
    return convertedArray;
  }

  const renderApproverSectionRadioBtn = () => {
    let _radioButtonArray = [];
    _radioButtonArray = translateWordForRadio(props.guideradiobutton_eSignApproverCC.options);
    _radioButtonArray = _radioButtonArray.map(item => {
      let retItem = {};
      retItem.label = item.split('=')[1];
      retItem.value = item.split('=')[0] === "true" || item.split('=')[0] === "false" ? JSON.parse(item.split('=')[0]) : item.split('=')[0];
      return retItem;
    })

    const _radioButtonJsx = (
      <RadioButton
        radioOptions={_radioButtonArray}
        handleChange={(event) => handleApproverSectionRadioButton(event)}
        selectedOption={state.showApproverCcSection}
        name={props.guideradiobutton_eSignApproverCC.name}
        id={props.guideradiobutton_eSignApproverCC.name}
      />
    )

    return _radioButtonJsx
  }

  return (
    <div className='esign-signatory-modal'>
      <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
        <ModalHeader title={props.translations(props.notification_DeclarationSignatureNotification.titleEsign)} />
        <ModalBody>
          <Banner
            bannerType="primary"
            bannerId="esign-signatory-banner"
            actionText="Close"
            actionCallback={props.onBannerClose}
            hide={props.bannersVisibility['esign-signatory-banner']}
          >
            {props.translations(props.notification_DeclarationSignatureNotification.textEsign)} <br /><br />
            {props.translations(props.notification_DeclarationSignatureNotification.messageEsign)} <br /><br />
            {props.translations(props.notification_DeclarationSignatureNotification.messageEsignCc)}
          </Banner>
          <br />
          {
            props.signatoryModalResponse && props.signatoryModalResponse['responseData'] && props.signatoryModalResponse['responseData'].map((v, i) => {
              return (
                <div className="gdocs-signatory-modal-content" key={i}>
                  <fieldset>
                    <legend className='esign-signatory-modal__legend'>
                      {renderLabel(v, i)}
                    </legend>
                    <dl className='signatory-fname-lname'>
                      <div>
                        <dt className="first-name">{props.translations(props.guidetextbox_firstNameDecSign.title)} :</dt>
                        <dd>{v.firstName}</dd>
                      </div>
                      <div>
                        <dt className="last-name">{props.translations(props.guidetextbox_lastNameDecSign.title)} :</dt>
                        <dd>{v.lastName}</dd>
                      </div>
                    </dl>
                    <div>
                      <label className="email" htmlFor={`signatory-email-${i + 1}`}>{props.translations(props.guidetextbox_emailAddressDecSign.title)} :</label>
                      <input
                        type="text"
                        name={`signatoryEmail${i + 1}`}
                        id={'signatory-email-' + (i + 1)}
                        aria-describedby={`signatory-email-error-${i + 1}`}
                        defaultValue={v[`emailAddress`] ? v.emailAddress : state[`email${i + 1}`]} // maybe the default value should be ''
                        onChange={(e) => handleEmailChange(e, i + 1, state[`email${i + 1}`])}
                      />
                      <p className='error-message error-message__email' id={`signatory-email-error-${i + 1}`} role='alert'>
                        {state[`isEmailValid${i + 1}`] === false ? (
                          <React.Fragment>
                            <i className='icon icon-circle-delete-solid' aria-hidden='true'></i>
                            {state[`errorMsgEmail${i + 1}`]}
                          </React.Fragment>
                        ) : ''}
                      </p>
                      {/* {!state[`isEmailValid${i + 1}`] ? <p className='error-message error-message__email' id={`signatory-email-error-${i + 1}`}>{state[`errorMsgEmail${i + 1}`]}</p> : <span></span>} */}
                    </div>
                    <fieldset className='form-row hsbcnet-telephone'>
                      <legend className='telephone-form-column'>{props.translations(props.guidetextbox_officeTelephoneNumberEsign.title)} :</legend>
                      <div className='telephone-form-column'>
                        <div className="dropdown-combo-wrapper" role='group'>
                          <div className="combo-dropdown">
                            <div className='telephone-wrapper'>
                              <TelephoneNumber
                                countryCodes={props.telephoneCountryCodes}
                                areaCodes={props.telephoneAreaCodes}
                                countryCode={state.esignSignatories[i] && state.esignSignatories[i][getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name, props.guidedropdownlist_CountryCode.name)]}
                                areaCode={state.esignSignatories[i] && state.esignSignatories[i][getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name, props.guidedropdownlist_AreaCode.name)]}
                                number={state.esignSignatories[i] && state.esignSignatories[i][props.guidetextbox_officeTelephoneNumberEsign.name]}
                                onChange={(event) => { handleEsignPhoneChange(event, i) }}
                                properties={
                                  {
                                    countryCode: {
                                      label: props.translations(props.guidedropdownlist_CountryCode.label),
                                      name: getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name,
                                        props.guidedropdownlist_CountryCode.name),
                                      id: `signatory-phone-country-code-${i + 1}`
                                    },
                                    areaCode: {
                                      label: props.translations(props.guidedropdownlist_AreaCode.label),
                                      name: getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name,
                                        props.guidedropdownlist_AreaCode.name),
                                      id: `signatory-phone-area-code-${i + 1}`
                                    },
                                    number: {
                                      label: props.translations(props.guidetextbox_officeTelephoneNumberEsign.label),
                                      name: props.guidetextbox_officeTelephoneNumberEsign.name,
                                      id: `signatory-phone-number-${i + 1}`
                                    }
                                  }
                                }
                                a11yProperties={
                                  {
                                    ariaDescribedBy: `signatory-phone-error-${i + 1}`
                                  }
                                }
                              ></TelephoneNumber>
                            </div>
                          </div>
                          <div className="gdocs-clear-float"></div>
                        </div>
                        <p className='error-message' id={`signatory-phone-error-${i + 1}`} role='alert'>
                          {state[`isSignatoryPhoneValid${i + 1}`] === false ? (
                            <React.Fragment>
                              <i className='icon icon-circle-delete-solid' aria-hidden='true'></i>
                              {state[`errorMsgSignatoryPhone${i + 1}`]}
                            </React.Fragment>
                          ) : ''}
                        </p>
                        {/* {!state[`isSignatoryPhoneValid${i + 1}`] ? <p className='error-message' id={`signatory-phone-error-${i + 1}`}>{state[`errorMsgSignatoryPhone${i + 1}`]}</p> : null} */}
                      </div>
                    </fieldset>
                  </fieldset>
                </div>
              )
            })
          }
          <div className='esign-approver-radio-section'>
            <h5 id='esign-approver-cc-label'>
              {props.translations(props.guideradiobutton_eSignApproverCC.title)}
            </h5>
            <div className="esign-approver-radio-button" role="radiogroup" aria-labelledby="esign-approver-cc-label">
              {renderApproverSectionRadioBtn()}
            </div>
          </div>
          {state.showApproverCcSection === 'approver' ?
            <div className="gdocs-signatory-modal-content">
              <fieldset>
                <legend className='esign-signatory-modal__legend'>
                  {props.translations(props.static_text_documentation.Approver)}
                </legend>
                <div>
                  <label className="first-name" htmlFor='approver-first-name'>{props.translations(props.guidetextbox_firstNameDecSign.title)} :</label>
                  <input
                    type="text"
                    name="approverFirstName"
                    id="approver-first-name"
                    aria-describedby="approver-first-name-error"
                    value={state.approverFirstName}
                    defaultValue=""
                    onChange={(e) => handleApproverNameEmailChange(e)}
                  />
                  <p className='error-message error-message__email' id='approver-first-name-error' role='alert'>
                    {state.isApproverFirstNameValid === false ? (
                      <React.Fragment>
                        <i className='icon icon-circle-delete-solid' aria-hidden='true'></i>
                        {state.errorMsgApproverFirstName}
                      </React.Fragment>
                    ) : ''}
                  </p>
                  {/* {!(state.isApproverFirstNameValid) ? <p className='error-message error-message__email' id='approver-first-name-error'>{state.errorMsgApproverFirstName}</p> : <span></span>} */}
                </div>
                <div>
                  <label className="last-name" htmlFor="approver-last-name">{props.translations(props.guidetextbox_lastNameDecSign.title)} :</label>
                  <input
                    type="text"
                    name="approverLastName"
                    id="approver-last-name"
                    aria-describedby="approver-last-name-error"
                    value={state.approverLastName}
                    defaultValue=""
                    onChange={(e) => handleApproverNameEmailChange(e)}
                  />
                  <p className='error-message error-message__email' id='approver-last-name-error' role='alert'>
                    {state.isApproverLastNameValid === false ? (
                      <React.Fragment>
                        <i className='icon icon-circle-delete-solid' aria-hidden='true'></i>
                        {state.errorMsgApproverLastName}
                      </React.Fragment>
                    ) : ''}
                  </p>
                  {/* {!(state.isApproverLastNameValid) ? <p className='error-message error-message__email' id='approver-last-name-error'>{state.errorMsgApproverLastName}</p> : <span></span>} */}
                </div>
                <div>
                  <label className="email" htmlFor="approver-email">{props.translations(props.guidetextbox_emailAddressDecSign.title)} :</label>
                  <input
                    type="text"
                    name="approverEmail"
                    id="approver-email"
                    aria-describedby="approver-email-error"
                    defaultValue=""
                    value={state.approverEmail}
                    onChange={(e) => handleApproverNameEmailChange(e)}
                  />
                  <p className='error-message error-message__email' id='approver-email-error' role='alert'>
                    {state.isApproverEmailValid === false ? (
                      <React.Fragment>
                        <i className='icon icon-circle-delete-solid' aria-hidden='true'></i>
                        {state.errorMsgApproverEmail}
                      </React.Fragment>
                    ) : ''}
                  </p>
                  {/* {!(state.isApproverEmailValid) ? <p className='error-message error-message__email' id='approver-email-error'>{state.errorMsgApproverEmail}</p> : <span></span>} */}
                </div>
                <fieldset className='form-row hsbcnet-telephone'>
                  <legend className='telephone-form-column'>{props.translations(props.guidetextbox_officeTelephoneNumberEsign.title)} :</legend>
                  <div className='telephone-form-column'>
                    <div className="dropdown-combo-wrapper">
                      <div className="combo-dropdown">
                        <div className='telephone-wrapper'>
                          <TelephoneNumber
                            countryCodes={props.telephoneCountryCodes}
                            areaCodes={props.telephoneAreaCodes}
                            countryCode={state.esignApprover && state.esignApprover[getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name, props.guidedropdownlist_CountryCode.name)]}
                            areaCode={state.esignApprover && state.esignApprover[getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name, props.guidedropdownlist_AreaCode.name)]}
                            number={state.esignApprover && state.esignApprover[props.guidetextbox_officeTelephoneNumberEsign.name]}
                            onChange={(event) => { handleEsignApproverPhoneChange(event) }}
                            properties={
                              {
                                countryCode: {
                                  label: props.translations(props.guidedropdownlist_CountryCode.label),
                                  name: getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name,
                                    props.guidedropdownlist_CountryCode.name),
                                  id: 'approver-phone-country-code'
                                },
                                areaCode: {
                                  label: props.translations(props.guidedropdownlist_AreaCode.label),
                                  name: getTelephoneKey(props.guidetextbox_officeTelephoneNumberEsign.name,
                                    props.guidedropdownlist_AreaCode.name),
                                  id: 'approver-phone-area-code'
                                },
                                number: {
                                  label: props.translations(props.guidetextbox_officeTelephoneNumberEsign.label),
                                  name: props.guidetextbox_officeTelephoneNumberEsign.name,
                                  id: 'approver-phone-number'
                                }
                              }
                            }
                            a11yProperties={
                              {
                                ariaDescribedBy: 'approver-phone-error'
                              }
                            }
                          ></TelephoneNumber>
                        </div>
                      </div>
                      <div className="gdocs-clear-float"></div>
                    </div>
                    <p className='error-message' id='approver-phone-error' role='alert'>
                      {state[`isApproverPhoneValid`] === false ? (
                        <React.Fragment>
                          <i className='icon icon-circle-delete-solid' aria-hidden='true'></i>
                          {state[`errorMsgApproverPhone`]}
                        </React.Fragment>
                      ) : ''}
                    </p>
                    {/* {!state[`isApproverPhoneValid`] ? <p className='error-message' id='approver-phone-error'>{state[`errorMsgApproverPhone`]}</p> : null} */}
                  </div>
                </fieldset>
              </fieldset>
            </div>
            :
            state.showApproverCcSection === 'cc' ?
              <div className="gdocs-signatory-modal-content">
                <p><b>{props.translations(props.static_text_documentation.copyParty)}</b></p>
                <div>
                  <label className="email" htmlFor="cc-email">{props.translations(props.guidetextbox_emailAddressDecSign.title)} :</label>
                  <input
                    type="text"
                    name="ccEmail"
                    id="cc-email"
                    aria-describedby="cc-email-error"
                    defaultValue=""
                    value={state.ccEmail}
                    onChange={(e) => handleApproverNameEmailChange(e)}
                  />
                  <p className='error-message error-message__email' id='cc-email-error' role='alert'>
                    {state.isCcEmailValid === false ? (
                      <React.Fragment>
                        <i className='icon icon-circle-delete-solid' aria-hidden='true'></i>
                        {state.errorMsgCcEmail}
                      </React.Fragment>
                    ) : ''}
                  </p>
                  {/* {!(state.isCcEmailValid) ? <p className='error-message error-message__email' id='cc-email-error'>{state.errorMsgCcEmail}</p> : <span></span>} */}
                </div>
                <br />
              </div>
              :
              null
          }
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default" onClick={props.toggleDialog}>{props.translations(props.static_text_documentation.signatoriesCancelbuttonText)}</button>
          <button className="gdocs-btn-primary" id={handleSubmitDisable() === true ? 'esign-submit-btn__disabled' : 'esign-submit-btn__enabled'} disabled={handleSubmitDisable()} onClick={() => props._onSubmitpop(state)}>
            {props.translations(props.static_text_documentation.signatoriesSubmitbuttonText)}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

const ESignConfirmationModal = (props) => {
  return (
    props.static_text_documentation ?
      (<Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
        <ModalHeader title={props.translations(props.static_text_documentation.title)} />
        <ModalBody>
          {props.translations(props.static_text_documentation.esignConfirmationPopupMessage)}
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default" onClick={props.toggleDialog}>{props.translations(props.static_text_documentation.sendtosimplesignconfirmNobuttonText)}</button>
          <button className="gdocs-btn-primary" onClick={props._onSubmitpop}>{props.translations(props.static_text_documentation.sendtosimplesignconfirmYesbuttonText)}</button>
        </ModalFooter>
      </Modal>) : null
  );
}

const SentToESignModal = (props) => {
  return (
    props.sentForEsignModalDetails ?
      (<Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
        <ModalHeader title={props.translations(props.sentForEsignModalDetails.title)} />
        <ModalBody>
          {props.docStatusData && props.docStatusData.map((statusData) => {
            if (props.currentCaseId === statusData.id) {
              return (
                statusData.eSignStatus && statusData.eSignStatus.overallStatus === 'in-progress' ? props.translations(props.sentForEsignModalDetails.description) : props.translations(props.sentForEsignNegativeMsg)
              )
            }
          })}
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-primary" onClick={props.toggleDialog}>{props.translations(props.sentForEsignModalDetails.OkbuttonText)}</button>
        </ModalFooter>
      </Modal>) : null
  )
}

const CancelESignConfirmationModal = (props) => {
  return (
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.eSignCancelPopup.static_text_esignCancelPopup.cancelEsignButton)} />
      <ModalBody>
        {props.translations(props.eSignCancelPopup.static_text_esignCancelPopup.cancelEsignConfirmationMessage)}
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-default" onClick={props.toggleDialog}>{props.translations(props.static_text_documentation.sendtosimplesignconfirmNobuttonText)}</button>
        <button className="gdocs-btn-primary" onClick={props._onSubmitpop}>{props.translations(props.static_text_documentation.sendtosimplesignconfirmYesbuttonText)}</button>
      </ModalFooter>
    </Modal>
  );
}

const EsignCanceledModal = (props) => {
  return (
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.eSignCancelPopup.static_text_esignCancelPopup.esignCancelledHeaderTitle)} />
      <ModalBody>
        {props.translations(props.eSignCancelPopup.static_text_esignCancelPopup.esignCancelledMessage)}
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-primary" onClick={props.toggleDialog}>{props.translations(props.okButtonText)}</button>
      </ModalFooter>
    </Modal>
  );
}

const FinalizeModal = (props) => {
  return (
    props.static_text_documentation &&
    (<Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.static_text_documentation.title)} />
      <ModalBody>
        <p>{props.translations(props.static_text_documentation.par1)}</p>
        <p>{props.translations(props.static_text_documentation.par2)}</p>
        <p>{props.translations(props.static_text_documentation.par3)}</p>
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-default" onClick={props.doNotFinalize}>{props.translations(props.static_text_documentation.cancelText)}</button>
        <button className="gdocs-btn-primary" onClick={props._onFinalizedpop}>{props.translations(props.static_text_documentation.buttonText)}</button>
      </ModalFooter>
    </Modal>)
  );
}

const MarkedSignedModal = (props) => {
  return (
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass} history={props.history}>
      <ModalHeader title={props.translations(props.page_title_mainTitle.pageHeading)} />
      <ModalBody>
        <div>
          {
            props.currentCase ? (
              <p className="entity-details-header"><b>{`${props.currentCase.entityName}, Case ${props.currentCase._caseId}`}</b></p>
            ) : ''
          }
          {props._renderForm}
          <hr></hr>
          <label className="add-scanned-uploads-label">{props.translations(props.static_text_scannedUploads.text)}</label>
          <div className="gdocs-file-upload">
            <label htmlFor="scanned-upload" className="gdocs-file-upload__label"><i className="icon icon-add"></i>{props.translations(props.button_addNew.text)}</label>
            <input id="scanned-upload" className="gdocs-file-upload__input" type="file" name="scanned-upload" onChange={props.onFileUpload} />
          </div>
          <ul className="scanned-uploads-section">
            {
              props.scannedUploads !== undefined && props.scannedUploads.length > 0 && props.scannedUploads.map((upload) => {
                return <li key={upload.id} className="scanned-upload-item clearfix">{upload.fileName} <i className="icon icon-bin" role="button" onClick={props.onFileDelete.bind(this, upload)}></i></li>
              })
            }
          </ul>
        </div>
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-default gdocs-mright-15" onClick={props.toggleDialog}>{props.translations(props.button_cancel.text)}</button>
        <button className="gdocs-btn-primary" onClick={props._onMarkedSignedPopUp}>{props.translations(props.button_saveChanges.text)}</button>
      </ModalFooter>
    </Modal>
  );
}

const SentToSimpleSignModal = (props) => {
  return (
    props.sentForEsignModalDetails ?
      (<Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
        <ModalHeader title={props.translations(props.sentForEsignModalDetails.title)} />
        <ModalBody>
          {props.responseReceived === true ? props.translations(props.sentForEsignModalDetails.description) : props.translations(props.sentForEsignNegativeMsg)}
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-primary" onClick={props.toggleDialog}>{props.translations(props.sentForEsignModalDetails.OkbuttonText)}</button>
        </ModalFooter>
      </Modal>) : null
  )
}

const SignatoryConfirmationModal = (props) => {
  return (
    props.static_text_documentation ?
      (<Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
        <ModalHeader title={props.translations(props.static_text_documentation.title)} />
        <ModalBody>
          {props.translations(props.static_text_documentation.description)}
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default" onClick={props._onCanceldpop}>{props.translations(props.static_text_documentation.sendtosimplesignconfirmNobuttonText)}</button>
          <button className="gdocs-btn-primary" onClick={props._onSubmitpop}>{props.translations(props.static_text_documentation.sendtosimplesignconfirmYesbuttonText)}</button>
        </ModalFooter>
      </Modal>) : null
  );
}

const SignatoryModal = (props) => {
  const [state, setState] = useState({
    isEmailValid1: true, isEmailValid2: true, isEmailValid3: true, isEmailValid4: true,
    isPhoneValid1: true, isPhoneValid2: true, isPhoneValid3: true, isPhoneValid4: true,
  })

  const handleEmailChange = (event, index, email) => {
    const value = event.target.value;
    const name = event.target.name;
    const emailPattern = /^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{1,}))$/

    setState({
      ...state,
      [name]: value,
      [`isEmailValid${index}`]: emailPattern.test(value),
      [`errorMsgEmail${index}`]: value !== "" && emailPattern.test(value) ? "" : "Please enter a valid email address"
    })
  }

  const handlePhoneChange = (event, index, phone) => {
    const value = event.target.value;
    const name = event.target.name;
    const phonePattern = /\d/;

    setState({
      ...state,
      [name]: value,
      [`isPhoneValid${index}`]: phonePattern.test(value),
      [`errorMsgPhone${index}`]: (value !== "" && phonePattern.test(value)) ? "" : "Please enter the Mobile number"
    })
  }

  const handleSubmitDisable = () => {
    const responseDataLength = props.signatoryModalResponse && props.signatoryModalResponse['responseData'].length

    let disable = false;
    for (let i = 0; i < responseDataLength; i++) {
      let email = state['email' + `${i + 1}`] ? state['email' + `${i + 1}`] : props.signatoryModalResponse['responseData'][i].emailAddress
      let phone = state['phone' + `${i + 1}`] ? state['phone' + `${i + 1}`] : props.signatoryModalResponse['responseData'][i].telephoneNumber
      let mailError = state['errorMsgEmail' + `${i + 1}`]
      let phoneError = state['errorMsgPhone' + `${i + 1}`]
      if (email === undefined || email === null || email === "" || mailError === "Please enter a valid email address" ||
        phone === undefined || phone === null || phone === "" || phoneError === "Please enter the Mobile number") {
        disable = true;
      }
    }
    return disable;
  }

  const renderLabel = (param, index) => {
    const contactType = param.contactType
    const firstName = param.firstName

    if (contactType === "Declaration Signatory") {
      index++;
      return (`${contactType} ${index}`)
    } else if (contactType === "Primary Security Contact") {
      const filteredArr = props.signatoryModalResponse && props.signatoryModalResponse['responseData'] && props.signatoryModalResponse['responseData'].filter(item => item.contactType === contactType) || []
      for (let i = 0; i <= filteredArr.length; i++) {
        if (filteredArr[i].firstName === firstName && filteredArr[i].lastName === param.lastName && filteredArr[i].telephoneNumber
          === param.telephoneNumber && filteredArr[i].emailAddress === param.emailAddress) {
          i++;
          return (`${contactType} ${i}`)
        }
      }
    } else {
      if (contactType === "Additional Contact") {
        const filteredArr = props.signatoryModalResponse && props.signatoryModalResponse['responseData'] && props.signatoryModalResponse['responseData'].filter(item => item.contactType === contactType) || []
        for (let i = 0; i <= filteredArr.length; i++) {
          if (filteredArr[i].firstName === firstName && filteredArr[i].lastName === param.lastName && filteredArr[i].telephoneNumber
            === param.telephoneNumber && filteredArr[i].emailAddress === param.emailAddress) {
            i++;
            return (`${contactType} ${i}`)
          }
        }
      }
    }
  }

  return (
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.static_text_documentation.title)} />
      <ModalBody>
        <Banner
          bannerType="primary"
          bannerId="ci-customer-banner"
        // actionCallback={this.onBannerClose}
        >
          {props.translations(props.notification_DeclarationSignatureNotification.text)} <br /><br />
          {props.translations(props.notification_DeclarationSignatureNotification.message)}
        </Banner>
        {
          props.signatoryModalResponse && props.signatoryModalResponse['responseData'] && props.signatoryModalResponse['responseData'].map((v, i) => {
            return (
              <div className="gdocs-signatory-modal-content" key={i}>
                <p><b>{renderLabel(v, i)}</b></p>
                <p><label className="first-name">{props.translations(props.guidetextbox_firstNameDecSign.title)} :</label>{v.firstName}</p>
                <p><label className="last-name">{props.translations(props.guidetextbox_lastNameDecSign.title)} :</label>{v.lastName}</p>
                <p><label className="job-title-dec-sign">{props.translations(props.guidetextbox_jobTitleDecSign.title)} :</label>{v.jobTitle}</p>
                <p><label className="email">{props.translations(props.guidetextbox_emailAddressDecSign.title)} :</label>
                  <input
                    type="text"
                    name={`email${i + 1}`}
                    defaultValue={v[`emailAddress`] ? v.emailAddress : state[`email${i + 1}`]}
                    onChange={(e) => handleEmailChange(e, i + 1, state[`email${i + 1}`])}
                  />
                  {!state[`isEmailValid${i + 1}`] ? <p className='error-message'>{state[`errorMsgEmail${i + 1}`]}</p> : <span></span>}
                </p>
                <p><label className="mobile">{props.translations(props.guidetextbox_officeTelephoneNumberDecSign.title)} :</label>
                  <input
                    type="text"
                    name={`phone${i + 1}`}
                    defaultValue={v[`telephoneNumber`] ? v.telephoneNumber : state[`phone${i + 1}`]}
                    onChange={(e) => handlePhoneChange(e, i + 1, state[`phone${i + 1}`])}
                  />
                  <br /><label className='mobileHelpText' >{props.translations(props.guidetextbox_officeTelephoneNumberDecSign.helpText)}</label>
                  {!state[`isPhoneValid${i + 1}`] ? <p className='error-message'>{state[`errorMsgPhone${i + 1}`]}</p> : <span></span>}

                </p >
              </div >
            )
          })
        }
      </ModalBody >
      <ModalFooter>
        <button className="gdocs-btn-default" onClick={props._onCanceldpop}>{props.translations(props.static_text_documentation.signatoriesCancelbuttonText)}</button>
        <button
          className="gdocs-btn-primary" disabled={handleSubmitDisable()} onClick={() => props._onSubmitpop(state)}>{props.translations(props.static_text_documentation.signatoriesSubmitbuttonText)}</button>
      </ModalFooter >
    </Modal >
  );
}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    lang: state.lang,
    userRole: state.auth.userDetails.roleDetails.role,
    caseMenu: state.caseMenuInfo,
    customer: state.auth.userDetails.roleDetails.customer,
    owningCase: electOwningCase(state.cases),
    isTbtEnabled: isTbtEnabled(state.auth.userDetails)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    setTabsStatus: (tabName, isComplete) => {
      dispatch(setTabsStatus(tabName, isComplete))
    },
    enableTab: (tabName) => {
      dispatch(enableTab(tabName))
    },
    disableTab: (tabName) => {
      dispatch(disableTab(tabName))
    },
    updateDarkTitleBarCaseStatus: caseStatus => {
      dispatch(updateDarkTitleBarCaseStatus(caseStatus))
    },
    enableCaseBodyFooterBtn: (btnName) => {
      dispatch(enableCaseBodyFooterBtn(btnName))
    },
    disableCaseBodyFooterBtn: (btnName) => {
      dispatch(disableCaseBodyFooterBtn(btnName))
    },
    disableAllCaseBodyFooterBtns: () => {
      dispatch(disableAllCaseBodyFooterBtns())
    },
    updateCasesWithStatus: (caseStatuses) => {
      dispatch(updateCasesWithStatus(caseStatuses));
    },
    setCases: ({ cases, entities }) => {
      dispatch(setCases(cases, entities));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CaseDocument);

// <a onClick={(e) => {this.downloadDraft(this.state.data[i].id)}}>



// WEBPACK FOOTER //
// ./src/components/CaseBody/Documentation/index.js